import type { AfterViewInit, OnDestroy, OnInit } from '@angular/core';
import { ChangeDetectorRef, Component, inject, ViewChild } from '@angular/core';
import type { ValidatorFn } from '@angular/forms';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { FeatureFlag } from 'app/common/enums/feature-flag.enum';
import { isNullOrUndefined } from 'is-what';
import moment from 'moment-timezone';
import { finalize } from 'rxjs';

import type { IMyDateModel } from '../../common/legacy-lib/angular-mydatepicker/interfaces/my-date-model.interface';
import type { IAngularMyDpOptions } from '../../common/legacy-lib/angular-mydatepicker/interfaces/my-options.interface';
import { ErrorNavigationService } from '../../mega-exchange/services/error-navigation.service';
import { StringConstants } from '../../rcr-exchange/constants/string-constants';
import { DownloadPdfService } from '../../shared/services/download-pdf.service';
import { DownloadXlsxService } from '../../shared/services/download-xlsx.service';
import { ErrorHandlerService } from '../../shared/services/error-handler.service';
import { FmLoadingPageService } from '../../shared/services/fm-loading-page.service';
import { UserService } from '../../shared/services/user.service';
import { XlsxToJsonService } from '../../shared/services/xlsx-to-json.service';
import { CollateralAnalyzerDetailsComponent } from '../collateral-analyzer-details/collateral-analyzer-details.component';
import { CollateralAnalyzerStatisticsComponent } from '../collateral-analyzer-statistics/collateral-analyzer-statistics.component';
import { CollateralAnalyzerTableComponent } from '../collateral-analyzer-table/collateral-analyzer-table.component';
import { AnalyzerDisclosureService } from '../services/analyzer-disclosure.service';
import { MegasService } from '../services/megas.service';
import { PassDataService } from '../services/pass-data.service';

const padding = '000000';

@Component({
  standalone: false,
  selector: 'invd-collateral-analyzer-upload-file',
  templateUrl: './collateral-analyzer-upload-file.component.html',
  styleUrls: ['./collateral-analyzer-upload-file.component.scss'],
})
export class CollateralAnalyzerUploadFileComponent implements OnInit, AfterViewInit, OnDestroy {
  private readonly cdr = inject(ChangeDetectorRef);
  @ViewChild(CollateralAnalyzerTableComponent, { static: true })
  public collateralAnalyzerTableComponent: CollateralAnalyzerTableComponent;

  @ViewChild(CollateralAnalyzerStatisticsComponent, { static: true })
  public collateralAnalyzerStatisticsComponent: CollateralAnalyzerStatisticsComponent;
  @ViewChild(CollateralAnalyzerDetailsComponent, { static: true })
  public collateralAnalyzerDetailsComponent: CollateralAnalyzerDetailsComponent;

  isAllowToNavigateAway = false;
  public hasFileExtensionError = false;
  isFileEmpty = false;
  displayFileDataSelectionPopup = false;
  public cusipPlaceholder = 'A';
  public ofacePlaceholder = 'B';
  dropDownMenuItems = ['A', 'B'];
  isRememberSelectionChecked = false;
  hasHeaderRow = true;
  fileName = '';
  public selectedCusip = '';
  public selectedOface = '';
  public validateCollateralReq: any[] = [];
  public validateCollateralEditReq: string[] = [];
  public exceldata: any;
  showInitialScreen = true;
  validatedCollateralPoolCount = 0;
  collateralValidatedPoolList: any;
  collateralValidatedPoolListRes: any;
  public isFileCorrupted = false;
  validationErrorList: any;
  genericErrorMesasgesList: any;
  hasValidationErrors = false;
  showBannerErrorMsg = '';
  public checkFactorDataAvailable = true;
  public showEditCollateralPopup = false;
  public showCreateMegaPopup = false;
  public showAddCollateralPopup = false;
  public showFreddieIssuedAmtWarning = false;
  public excelSheetContent: any;
  public cusipEditInput = '';
  public oFaceEditInput = '';
  public cusipEditedValue = '';
  public oFaceEditedValue = '';
  public oFaceIntialValue = '';
  public editIndexNumber = 0;
  public cusipAddInput = '';
  public oFaceAddInput = '';
  public isFilePasswordProcted = false;
  public sheets: string[] = [];
  public sheetsPalceholder = 'Please select the tab';
  public selectedSheet = '';
  public excelColumnLengthCount: any;
  public isSheetDropdownOpen = false;
  public isCusipDropdownOpen = false;
  public isOfaceDropdownOpen = false;
  selectedRowsForDeletion: any[] = [];
  megaDetailsList: any;
  public hasFileLevelErrors = false;
  isEmptyRow = false;
  isCusipColumnEmpty = false;
  isOfaceColumnEmpty = false;
  isCellEmpty = false;
  emptyCellsArray: any = [];
  invalidCusipCellsArray: any = [];
  invalidOfaceCellsArray: any = [];
  ofaceLessThan1000CellsArray: any = [];
  isCellWithCusipInvalid = false;
  isCellWithOfaceInvalid = false;
  isOfaceLessThan1000 = false;
  isHeaderasFirstRowExits = true;
  public showCalendarBusyIndicator = true;
  public megaTypeVal = '';
  public mSfFixDateValue: any;
  public calcFeeRequest: any;
  protected collateralAnalyzerSettlemntDateOptions: IAngularMyDpOptions = {
    dateFormat: 'mm/dd/yyyy',
  };
  private rememberSheetSelection = '';
  public deleteFlow = false;
  public editFlow = false;
  public addFlow = false;
  public deletedRowCount = 0;
  public enableDeleteButton = false;
  public displayDeleteCollateralPopup = false;
  public addMessage = '';
  public editMessage = '';

  collateralAnalyzerForm: UntypedFormGroup;
  analyzerIntroDisclosureText = '';
  analyzerIntroFactorsText = '';
  analyzerIntroAsteriskText = '';
  public displayCancelCollateralPopup = false;
  public cancelPopUpTitle = '';
  public cancelUploadCollateralInfoText = '';
  public cancelButtonLabel = '';
  public compositeErrorList: any;
  public displaySucessMessage = '';
  public displaySucessHeader = '';
  public displayDeleteAllSucessMessage = '';
  public displayDeleteAllSucessHeader = '';
  public showCollateralUploadSucessMessage = false;
  public showDeleteAllSucessMessage = false;
  public showDropDownError = false;
  public isDealAmtLessThanOneThousand = false;
  public showSaveChangeButton = false;
  public FormatErrors: any = {};
  public cusipFormatErrors: string[] = [];
  public ofaceFormatErrors: string[] = [];
  public showCusipFormatError = false;
  public showOfaceFormatError = false;
  public deleteCollateralInfoText = '';
  public deleteAllCollateralInfoText = '';
  public disableAddCollateralButton = false;
  private prefix: string;
  private decimalSeparator: string;
  private thousandsSeparator: string;
  private suffix: string;
  public displayDeleteAllCollateralPopup = false;
  public isDeleteAllSelected = false;
  public tabName = '';
  public businessValidationErrors = false;
  public changeTabClicked = false;
  public createMegaTitle = '';
  public featuretoggle: any;
  public addLinkClicked = true;
  public editLinkClicked = true;
  public viewFeesButtonClicked = true;
  public validateCollateralClicked = true;

  public showAnalyzerDetails = false;
  public showAnalyzerStatistics = false;
  public showAnalyzerGrid = false;
  public disclosureReq: string[] = [];
  public LDshowDisclosureDetails = false;
  public tempMega = '';
  public disclosureWaDetailsRes: any;
  public disclosureSellerDetailsRes: any;
  public loanPurposeRes: any;
  public propertyTypeRes: any;
  public channelRes: any;
  public occupancyStatusRes: any;
  public numberOfUnitsRes: any;
  public originationYearRes: any;
  public stateRes: any;
  public servicersRes: any;
  public borrowersRes: any;
  public mortgageInsCancelIndRes: any;
  public mortgageInsCoverageRes: any;

  public mortgageLoanAmountQuartileRes: any;
  public interestRateQuartileRes: any;
  public netInterestRateCurrentQuartileRes: any;
  public loanTermQuartileRes: any;
  public loanAgeQuartileRes: any;
  public loanToValueQuartileRes: any;
  public combinedLoanToValueQuartileRes: any;
  public borrowerCreditScoreQuartileRes: any;
  public remainingMonthsToMaturityQuartileRes: any;
  public WAMonthsToMaturity = '';
  public netInterestRate = 0;
  public analyzerDetailsTabError = false;
  public analyzerStatisticsTabError = false;
  public enablePDFButton = false;

  private servicersResResolved: any;
  public quartileRes: any;
  private mortgageLoanAmountQuartileResResolved: any;
  private interestRateQuartileResResolved: any;
  private netInterestRateCurrentQuartileResResolved: any;
  private loanTermQuartileResResolved: any;
  private loanAgeQuartileResResolved: any;
  private loanToValueQuartileResResolved: any;
  private combinedLoanToValueQuartileResResolved: any;
  private borrowerCreditScoreQuartileResResolved: any;
  private remainingMonthsToMaturityQuartileResResolved: any;

  public analyzerDisclosureErrorMsg: string = StringConstants.ANALYZER_DISCLOSURE_DATA_ERROR;
  public analyzerStatisticsError: string[] = [];
  public analyzerDetailsError: string[] = [];

  public showIEAnalyzerPopUp = false;
  public dateSelected: any;

  public fannieIssued = 100;
  public freddieIssued = 0;

  public fmLoadingPageService = inject(FmLoadingPageService);
  private megaService = inject(MegasService);
  private passDataService = inject(PassDataService);
  private router = inject(Router);
  private xlsxToJsonService = inject(XlsxToJsonService);
  private downloadXlsx = inject(DownloadXlsxService);
  private errorHandlerService = inject(ErrorHandlerService);
  private errorNavService = inject(ErrorNavigationService);
  private downloadPdfService = inject(DownloadPdfService);
  private analyzerDisclosureService = inject(AnalyzerDisclosureService);
  private userService = inject(UserService);

  ngOnInit() {
    this.fmLoadingPageService.isLoaderRequesting.set(true);
    this.prefix = '$';
    this.suffix = '';
    this.decimalSeparator = '.';
    this.thousandsSeparator = ',';

    if (
      window.navigator.userAgent.includes('MSIE ') ||
      window.navigator.userAgent.includes('Trident/')
    ) {
      this.showIEAnalyzerPopUp = true;
    }

    this.createMegaTitle = StringConstants.ANALYZER_CREATE_MEGA_DISABLE_TOOLTIP_TEXT;
    this.changeTabClicked = false;
    this.analyzerStatisticsError = [];
    this.analyzerDetailsError = [];
    this.fileName = '';
    this.deleteFlow = false;
    this.showDropDownError = false;
    this.displayDeleteCollateralPopup = false;
    this.disableAddCollateralButton = false;
    this.displayDeleteAllCollateralPopup = false;
    this.enablePDFButton = false;
    this.analyzerDisclosureService.disclosureDetailsReset();
    this.setFeatureToggle();
    this.displaydisclosureDetails();
    this.disclosureDisplayPDFButton();
    this.displayDisclosureErrorDetails();
    if (this.passDataService.getGoBackEditFlag() === 'true') {
      this.fmLoadingPageService.isLoaderRequesting.set(false);
      this.showInitialScreen = false;
      this.showAnalyzerGrid = true;
      this.fileName = this.passDataService.getAnalyzerUploadedFileName();
      this.selectedSheet = this.passDataService.getAnalyzerUploadedFileSheetName();
      this.collateralValidatedPoolListRes =
        this.passDataService.getAnalyzerValidatedCollateralResponse();
      this.validatedCollateralPoolCount =
        this.collateralValidatedPoolListRes &&
        this.collateralValidatedPoolListRes.collateralDetails &&
        this.collateralValidatedPoolListRes.collateralDetails.length;
      this.collateralValidatedPoolList =
        this.collateralValidatedPoolListRes &&
        this.collateralValidatedPoolListRes.collateralDetails;
      this.megaDetailsList =
        this.collateralValidatedPoolListRes && this.collateralValidatedPoolListRes.megaDetails;
      this.freddieIssued =
        this.megaDetailsList &&
        (this.megaDetailsList.freddiupbAmountWithFactor / this.megaDetailsList.dealAmount) * 100;
      this.fannieIssued = 100 - this.freddieIssued;
      this.WAMonthsToMaturity = this.megaDetailsList && this.megaDetailsList.monthsToMaturity;
      this.netInterestRate = this.megaDetailsList && this.megaDetailsList.coupon;
      this.selectedCusip = this.passDataService.getDropDownSelectedCusip();
      this.selectedOface = this.passDataService.getDropDownSelectedOface();
      this.selectedSheet = this.passDataService.getAnalyzerUploadedFileSheetName();
      this.tabName = this.passDataService.getAnalyzerUploadedFileSheetName();
      this.hasHeaderRow = this.passDataService.getIsHeaderChecked();
      this.sheets = Object.keys(this.passDataService.getExcelSheetContent());
      this.updateValidationRequest();
    } else {
      this.showInitialScreen = true;
      this.checkFactorData();
      this.analyzerIntroDisclosureText = StringConstants.ANALYZER_INTRO_DISCLOSURE_TEXT;
      this.analyzerIntroFactorsText = StringConstants.ANALYZER_INTRO_FACTORS_TEXT;
      this.analyzerIntroAsteriskText = StringConstants.ANALYZER_INTRO_ASTERISK_TEXT;
      if (!isNullOrUndefined(this.xlsxToJsonService)) {
        this.xlsxToJsonService.checkPasswordProtected.subscribe((message) => {
          if (message !== null) {
            this.isFilePasswordProcted = true;
            this.showBannerErrorMsg = StringConstants.ANALYZER_SHOW_PASSWORD_PROTECTED_FILE_ERROR;
            this.hasFileLevelErrors = false;
          }
        });
      }
    }

    this.collateralAnalyzerForm = new UntypedFormGroup({
      MegaSettlemntDa: new UntypedFormControl(null, [Validators.required]),
    });
  }

  ngAfterViewInit() {
    this.onInitTooltipMessage();
  }

  ngOnDestroy() {
    this.fmLoadingPageService.isLoaderRequesting.set(false);
    this.displayCancelCollateralPopup = false;
    this.passDataService.setGoBackEditFlag('false');
    this.analyzerDisclosureService.disclosureDetailsReset();
  }

  canDeactivate(): Promise<boolean> | boolean {
    return this.isAllowToNavigateAway;
  }

  onConversion(event) {
    const conversionResult = JSON.parse(event.json.valueOf());
    this.exceldata = conversionResult[Object.keys(conversionResult)[0]];
    const sheetRows =
      this.excelSheetContent[this.selectedSheet] &&
      this.excelSheetContent[this.selectedSheet].sheet &&
      this.excelSheetContent[this.selectedSheet].sheet.length;
    if (
      Object.keys(conversionResult).length === 0 &&
      conversionResult.constructor === Object &&
      (sheetRows === 0 || isNullOrUndefined(sheetRows))
    ) {
      this.closeMessageBanner();
      this.isFileEmpty = true;
      this.showBannerErrorMsg = this.isFileEmpty
        ? StringConstants.ANALYZER_SHOW_FILE_EMPTY_ERROR
        : '';
    } else {
      this.enableDeleteButton = false;
      this.changeTabClicked = false;
      this.displayFileDataSelectionPopup = true;
      this.hasHeaderRow = true;
      this.closeMessageBanner();
      if (this.passDataService.getIsRememberSelectionCbChecked()) {
        this.isRememberSelectionChecked = true;
        this.selectedCusip =
          this.fileName === this.passDataService.getAnalyzerUploadedFileName()
            ? this.passDataService.getDropDownSelectedCusip()
            : 'A';
        this.selectedOface =
          this.fileName === this.passDataService.getAnalyzerUploadedFileName()
            ? this.passDataService.getDropDownSelectedOface()
            : 'B';
      } else {
        this.isRememberSelectionChecked = false;
        this.selectedCusip = 'A';
        this.selectedOface = 'B';
      }
    }
  }

  public showFileExtensionError(event) {
    this.hasFileExtensionError = event ? true : false;
    this.showBannerErrorMsg = this.hasFileExtensionError
      ? StringConstants.ANALYZER_SHOW_EXTENSION_ERROR
      : '';
  }

  public sheetsNameWithColumnCount(event) {
    let excelColumnLength = 2;
    this.excelColumnLengthCount = null;
    this.excelColumnLengthCount =
      event && event.sheetsNameWithColumnCount && event.sheetsNameWithColumnCount;
    this.selectedSheet = this.excelColumnLengthCount[0].split('@')[1];
    this.rememberSheetSelection = this.excelColumnLengthCount[0].split('@')[1];
    this.passDataService.setAnalyzerUploadedFileSheetName(this.selectedSheet);
    let excelColumnLengthCountVal = '2';
    excelColumnLengthCountVal = this.excelColumnLengthCount[0].split('@')[0];
    excelColumnLength =
      excelColumnLengthCountVal !== undefined ? parseInt(excelColumnLengthCountVal, 10) + 1 : 2;
    this.dropDownMenuItems =
      this.findExcelColumnDropdown() && this.findExcelColumnDropdown().splice(0, excelColumnLength);
  }

  public getExcelSheetsContent(event) {
    this.sheets = [];
    this.sheets = Object.keys(event.getExcelSheetsContent);
    this.excelSheetContent = event && event.getExcelSheetsContent;
    this.passDataService.setExcelSheetContent(this.excelSheetContent);
  }

  public showIsFileCorrupted(event) {
    this.isFileCorrupted = event ? true : false;
    if (this.isFileCorrupted) {
      this.displayFileDataSelectionPopup = false;
      this.showBannerErrorMsg = StringConstants.ANALYZER_SHOW_CORRUPTED_FILE_ERROR;
    } else if (this.isFileEmpty) {
      this.displayFileDataSelectionPopup = false;
    } else {
      this.displayFileDataSelectionPopup = true;
    }
  }

  public closeMessageBanner(): void {
    this.hasFileExtensionError = false;
    this.isFileEmpty = false;
    this.isFileCorrupted = false;
    this.hasValidationErrors = false;
    this.isFilePasswordProcted = false;
    this.hasFileLevelErrors = false;
  }

  public handleRememberSelection(event) {
    this.passDataService.setIsRememberSelectionCbChecked(event);
  }

  public showFileName(event) {
    const fileN = event.fileName ? event.fileName : '';
    this.fileName = fileN;
    this.passDataService.setAnalyzerUploadedFileName(fileN);
  }

  public handleChangeTab(): void {
    this.showInitialScreen = false;
    this.changeTabClicked = true;
    this.displayFileDataSelectionPopup = true;
    this.passDataService.setGoBackEditFlag(null);
    this.selectedSheet = this.passDataService.getAnalyzerUploadedFileSheetName();
    this.selectedCusip = this.passDataService.getDropDownSelectedCusip();
    this.selectedOface = this.passDataService.getDropDownSelectedOface();
    this.hasHeaderRow = this.passDataService.getIsHeaderChecked();
  }

  public displayEditCollateralPopup(event): any {
    this.cusipFormatErrors = [];
    this.ofaceFormatErrors = [];
    this.showSaveChangeButton = false;
    this.editMessage = StringConstants.COLLATERAL_ANALYZER_EDIT_MESSAGE;
    this.cusipEditInput = event && event.collateralPool && event.collateralPool.cusip;
    this.oFaceEditInput = this.currencyTransform(
      event && event.collateralPool && event.collateralPool.upbAmount,
    );
    this.editIndexNumber = event && event.index;
    this.cusipEditedValue = this.cusipEditInput;
    this.oFaceIntialValue = this.oFaceEditInput;
    this.showOfaceFormatError = false;
    this.showCusipFormatError = false;
    this.showEditCollateralPopup = event && event.showEditPopup ? true : false;
  }

  public editValuechange(event): void {
    const field: string = event.srcElement.name;
    const value = event.srcElement.value;
    if (field === 'cusip') {
      switch (this.checkCusipFormat(value)) {
        case 'invalid-input': {
          this.cusipFormatErrors = [];
          this.cusipFormatErrors.push(StringConstants.ANALYZER_CUSIP_FORMAT_ERROR);
          this.showCusipFormatError = true;
          this.showSaveChangeButton = false;
          this.businessValidationErrors = false;
          break;
        }
        default: {
          this.cusipFormatErrors = [];
          this.showCusipFormatError = false;
          this.cusipEditInput = value;
        }
      }
    } else if (field === 'oface') {
      const fMat = this.checkOFaceFormat(value);
      switch (fMat) {
        case 'invalid-input': {
          this.ofaceFormatErrors = [];
          this.ofaceFormatErrors.push(StringConstants.ANALYZER_OFACE_FORMAT_ERROR);
          this.showSaveChangeButton = false;
          this.showOfaceFormatError = true;
          this.businessValidationErrors = false;
          break;
        }
        case 'less-than-1000': {
          this.ofaceFormatErrors = [];
          this.ofaceFormatErrors.push(StringConstants.ANALYZER_OFACE_LESS_THAN_1000_FORMAT_ERROR);
          this.showSaveChangeButton = false;
          this.showOfaceFormatError = true;
          this.businessValidationErrors = false;
          break;
        }
        default: {
          this.ofaceFormatErrors = [];
          this.showOfaceFormatError = false;
          this.oFaceEditInput = this.currencyTransform(
            value.replace('$', '').replace(',', '').replace(/\,/g, ''),
          );
          break;
        }
      }
    }

    if (this.cusipEditInput !== '' && this.oFaceEditInput !== '') {
      if (this.ofaceFormatErrors.length === 0 && this.cusipFormatErrors.length === 0) {
        this.showSaveChangeButton = true;
      } else if (this.businessValidationErrors) {
        this.cusipFormatErrors = [];
        this.ofaceFormatErrors = [];
        this.showCusipFormatError = false;
        this.showOfaceFormatError = false;
        this.showSaveChangeButton = true;
      } else {
        this.showSaveChangeButton = false;
      }
    }
  }

  public editCollateral() {
    this.validateCollateralEditReq = [];
    let i = 1;
    const req: any = {};
    let reqPoolDetails: any = {};
    reqPoolDetails.rowNumber = i;
    reqPoolDetails.cusip = this.cusipEditInput && this.cusipEditInput.trim();
    reqPoolDetails.contribOrigFace = Number(
      this.oFaceEditInput.toString().replace('$', '').replace(',', '').replace(/\,/g, ''),
    );
    reqPoolDetails.isAddOrEdit = 'Y';
    this.validateCollateralEditReq.push(reqPoolDetails);

    this.validateCollateralReq.forEach((data) => {
      reqPoolDetails = {};
      if (this.validateCollateralReq.indexOf(data) !== this.editIndexNumber) {
        reqPoolDetails.rowNumber = i + 1;
        reqPoolDetails.cusip = data.cusip;
        reqPoolDetails.contribOrigFace = data.contribOrigFace;
        reqPoolDetails.isAddOrEdit = 'N';
        this.validateCollateralEditReq.push(reqPoolDetails);
        i++;
      }
    });

    req.poolDetails = this.validateCollateralEditReq;
    this.editFlow = true;
    if (this.editLinkClicked) {
      this.megaService.collateralAnalyzerValidateCollateral(req).subscribe({
        next: (data) => this.addEditCollateralValidationSuccess(data),
        error: (error) => this.handlevalidateCollateralServiceFail(error),
      });
    }

    this.editLinkClicked = false;
  }

  public addEditCollateralValidationSuccess(data: any) {
    if (data.modelPopUpErrors != null) {
      this.cusipFormatErrors = [];
      this.ofaceFormatErrors = [];
      data.modelPopUpErrors.forEach((item) => {
        if (item.cusipError) {
          this.cusipFormatErrors.push(item.errorMessage);
        } else {
          this.ofaceFormatErrors.push(item.errorMessage);
        }
      }, this);

      if (this.cusipFormatErrors.length > 0) {
        this.showCusipFormatError = true;
        this.showSaveChangeButton = false;
        this.disableAddCollateralButton = true;
      }

      if (this.ofaceFormatErrors.length > 0) {
        this.showOfaceFormatError = true;
        this.showSaveChangeButton = false;
        this.disableAddCollateralButton = true;
      }
      this.businessValidationErrors = true;
    } else {
      this.validateCollateralReq = this.validateCollateralEditReq;
      this.handlevalidateCollateralServiceSuccess(data);
      this.showEditCollateralPopup = false;
      this.showAddCollateralPopup = false;
    }
    this.addLinkClicked = true;
    this.editLinkClicked = true;
    this.cdr.markForCheck();
  }

  checkCusipFormat(cusip) {
    cusip = cusip && cusip.trim();
    return !isNullOrUndefined(cusip)
      ? /^[a-zA-Z0-9]+$/.test(cusip)
        ? cusip.length === 9
          ? cusip
          : 'invalid-input'
        : 'invalid-input'
      : null;
  }

  checkOFaceFormat(oface) {
    oface = oface && oface.trim();
    return !isNullOrUndefined(oface)
      ? /^[$]?([0-9]{1,3}?[,]?)*[0-9]{1,3}?[.]?[0-9]*?$/.test(oface)
        ? this.formatAmount(oface) !== 'invalid-input'
          ? this.formatAmount(oface) >= 1000
            ? this.formatAmount(oface)
            : 'less-than-1000'
          : 'invalid-input'
        : 'invalid-input'
      : null;
  }

  public displayAddCollateralPopup(): void {
    this.cusipAddInput = '';
    this.oFaceAddInput = '';
    this.addMessage = StringConstants.COLLATERAL_ANALYZER_ADD_MESSAGE;
    this.showAddCollateralPopup = true;
    this.disableAddCollateralButton = true;
    this.cusipFormatErrors = [];
    this.ofaceFormatErrors = [];
    this.showOfaceFormatError = false;
    this.showCusipFormatError = false;
  }

  public hideAddCollateralPopup(): void {
    this.cusipFormatErrors = [];
    this.ofaceFormatErrors = [];
    this.showAddCollateralPopup = false;
    this.addFlow = false;
  }

  public hideCreateMegaPopup(): void {
    this.showCreateMegaPopup = false;
  }

  public showCreateMegaDetailsPopup(megaType: any): void {
    if (this.freddieIssued > 50) {
      this.showFreddieIssuedAmtWarning = true;
    } else {
      this.continueMegaCreation(megaType);
    }
  }

  public continueMegaCreation(megaType: any): void {
    this.showFreddieIssuedAmtWarning = false;
    this.collateralAnalyzerForm.reset();
    this.mSfFixDateValue = null;
    this.showCollateralUploadSucessMessage = false;
    this.getSettlementDate(megaType);
    this.showCreateMegaPopup = true;
  }

  public cancelMegaCreation(): void {
    this.showFreddieIssuedAmtWarning = false;
  }

  public handleHeaderRowSelection(event) {
    this.hasHeaderRow = event;
  }

  public toggleSheetDropdown() {
    this.isSheetDropdownOpen = !this.isSheetDropdownOpen;
  }

  public closeSheetDropdown() {
    this.isSheetDropdownOpen = false;
  }

  public toggleCusipDropdown() {
    this.isCusipDropdownOpen = !this.isCusipDropdownOpen;
  }

  public closeCusipDropdown() {
    this.isCusipDropdownOpen = false;
  }

  public toggleOfaceDropdown() {
    this.isOfaceDropdownOpen = !this.isOfaceDropdownOpen;
  }

  public closeOfaceDropdown() {
    this.isOfaceDropdownOpen = false;
  }

  public handleDropdownSelectionCusip(dropDownCusip: string, _index) {
    this.isCusipDropdownOpen = false;
    this.selectedCusip = dropDownCusip;

    this.showDropDownError = this.selectedCusip === this.selectedOface ? true : false;
  }

  public handleDropdownSelectionOface(dropDownOface: string, _index) {
    this.isOfaceDropdownOpen = false;
    this.selectedOface = dropDownOface;
    this.showDropDownError = this.selectedCusip === this.selectedOface ? true : false;
  }

  public handleSelectedSheet(selectedSheet: string, _index) {
    this.isSheetDropdownOpen = false;
    this.showDropDownError = false;
    let excelColumnLength = 2;
    let excelColumnLengthCountVal = '2';
    let selectedCUSIPTemp = 'A';
    let selectedOfaceTemp = 'B';

    this.selectedSheet = selectedSheet;
    this.hasHeaderRow = true;
    this.excelColumnLengthCount.forEach(function (sheetDet) {
      if (sheetDet && sheetDet.split('@')[1] === selectedSheet) {
        excelColumnLengthCountVal = sheetDet.split('@')[0];
      }
    });
    excelColumnLength =
      excelColumnLengthCountVal !== undefined ? parseInt(excelColumnLengthCountVal, 10) + 1 : 2;
    this.dropDownMenuItems =
      this.findExcelColumnDropdown() && this.findExcelColumnDropdown().splice(0, excelColumnLength);

    if (this.passDataService.getIsRememberSelectionCbChecked()) {
      selectedCUSIPTemp = this.passDataService.getDropDownSelectedCusip();
      selectedOfaceTemp = this.passDataService.getDropDownSelectedOface();
      this.selectedCusip =
        this.dropDownMenuItems &&
        this.dropDownMenuItems.includes(selectedCUSIPTemp) &&
        this.dropDownMenuItems.includes(selectedOfaceTemp)
          ? selectedCUSIPTemp
          : 'A';
      this.selectedOface =
        this.dropDownMenuItems &&
        this.dropDownMenuItems.includes(selectedCUSIPTemp) &&
        this.dropDownMenuItems.includes(selectedOfaceTemp)
          ? selectedOfaceTemp
          : 'B';
      this.passDataService.setDropDownSelectedCusip(this.selectedCusip);
      this.passDataService.setDropDownSelectedOface(this.selectedOface);
    } else {
      this.selectedCusip = 'A';
      this.selectedOface = 'B';
    }

    this.showDropDownError = this.selectedCusip === this.selectedOface ? true : false;
  }

  public findExcelColumnDropdown(): any {
    const start = 'A';
    const stop = 'Z';

    const result = [];
    for (let idx = start.charCodeAt(0), end = stop.charCodeAt(0); idx <= end; ++idx) {
      result.push(String.fromCharCode(idx));
    }
    return result;
  }

  public hideFileDataSelectionPopup(): void {
    this.fmLoadingPageService.isLoaderRequesting.set(false);
    this.displayFileDataSelectionPopup = false;
    this.showDropDownError = false;
    this.enablePDFButton = this.enablePDFButton;
  }

  public validateCollateral(): void {
    this.displayFileDataSelectionPopup = false;
    this.fmLoadingPageService.isLoaderRequesting.set(true);
    this.validateCollateralReq = [];
    this.resetCellsForCUSIPAndOface();
    let excelSheetData: any = null;
    const cusipIndex =
      this.findExcelColumnDropdown() && this.findExcelColumnDropdown().indexOf(this.selectedCusip);
    const ofaceIndex =
      this.findExcelColumnDropdown() && this.findExcelColumnDropdown().indexOf(this.selectedOface);
    excelSheetData = this.passDataService.getExcelSheetContent();
    excelSheetData =
      excelSheetData &&
      excelSheetData[this.selectedSheet] &&
      excelSheetData[this.selectedSheet].sheet;

    if (isNullOrUndefined(excelSheetData)) {
      this.hasFileLevelErrors = true;
      this.genericErrorMesasgesList.push([
        StringConstants.ANALYZER_SHOW_MISSING_DATA_ERROR_MESSAGE,
      ]);
    }
    const findEmptyColumn = (arr, col) => arr && arr.map((x) => x[col]);

    const cusipColumnValues = findEmptyColumn(excelSheetData, cusipIndex);
    const ofaceCoumnValues = findEmptyColumn(excelSheetData, ofaceIndex);

    if (cusipColumnValues && cusipColumnValues.every((cusipVal) => cusipVal === undefined)) {
      this.isCusipColumnEmpty = true;
      this.genericErrorMesasgesList.push([
        StringConstants.ANALYZER_SHOW_MISSING_DATA_ERROR_MESSAGE,
      ]);
    } else if (ofaceCoumnValues && ofaceCoumnValues.every((ofaceCell) => ofaceCell === undefined)) {
      this.isOfaceColumnEmpty = true;
      this.genericErrorMesasgesList.push([
        StringConstants.ANALYZER_SHOW_MISSING_DATA_ERROR_MESSAGE,
      ]);
    }

    const cusipNewArray = [];
    const ofaceNewArray = [];
    if (this.hasHeaderRow && !(excelSheetData.length === 1)) {
      for (let i = 1; i < cusipColumnValues && cusipColumnValues.length; i++) {
        cusipNewArray.push(cusipColumnValues[i]);
      }
      for (let j = 1; j < ofaceCoumnValues && ofaceCoumnValues.length; j++) {
        ofaceNewArray.push(ofaceCoumnValues[j]);
      }
      const mergedArray = cusipNewArray && cusipNewArray.concat(ofaceNewArray);
      if (
        mergedArray.length > 1 &&
        !this.isOfaceColumnEmpty &&
        !this.isCusipColumnEmpty &&
        mergedArray.every((ele) => ele === undefined)
      ) {
        this.hasFileLevelErrors = true;
        this.genericErrorMesasgesList.push([
          StringConstants.ANALYZER_SHOW_MISSING_DATA_ERROR_MESSAGE,
        ]);
      }
    }

    if (
      !(this.isCusipColumnEmpty || this.isOfaceColumnEmpty) &&
      !isNullOrUndefined(excelSheetData)
    ) {
      excelSheetData.forEach(function (jsonRow, index) {
        const mBundle = {};
        if (this.hasHeaderRow && excelSheetData.length === 1) {
          this.genericErrorMesasgesList.push([
            StringConstants.ANALYZER_SHOW_MISSING_DATA_ERROR_MESSAGE,
          ]);
        } else if (this.hasHeaderRow && excelSheetData.length > 1) {
          this.buildCollateralValidationRequest(
            mBundle,
            index,
            jsonRow,
            cusipIndex,
            ofaceIndex,
            true,
          );
        } else {
          this.buildCollateralValidationRequest(
            mBundle,
            index,
            jsonRow,
            cusipIndex,
            ofaceIndex,
            false,
          );
        }
      }, this);
    }

    if (this.isCellEmpty && this.emptyCellsArray.length > 0) {
      this.genericErrorMesasgesList.push([
        StringConstants.ANALYZER_SHOW_MISSING_DATA_COLUMN_ERROR_MESSAGE +
          '(row: ' +
          this.formattedRangeOfRowNumbers(this.emptyCellsArray) +
          ')',
      ]);
    }

    if (
      this.isCellWithCusipInvalid &&
      this.isCellWithOfaceInvalid &&
      this.invalidCusipCellsArray.length > 0
    ) {
      this.genericErrorMesasgesList.push([
        StringConstants.ANALYZER_SHOW_CUSIP_COLUMN_INVALID_FORMAT_ERROR_MESSAGE +
          '(' +
          this.selectedCusip +
          ') is not in the proper format ' +
          '(row ' +
          this.formattedRangeOfRowNumbers(this.invalidCusipCellsArray) +
          ')',
      ]);
      this.genericErrorMesasgesList.push([
        StringConstants.ANALYZER_SHOW_OFACE_COLUMN_INVALID_FORMAT_ERROR_MESSAGE +
          '(' +
          this.selectedOface +
          ') is not in the proper format ' +
          '(row ' +
          this.formattedRangeOfRowNumbers(this.invalidOfaceCellsArray) +
          ')',
      ]);
    } else if (this.isCellWithCusipInvalid && this.invalidCusipCellsArray.length > 0) {
      this.genericErrorMesasgesList.push([
        StringConstants.ANALYZER_SHOW_CUSIP_COLUMN_INVALID_FORMAT_ERROR_MESSAGE +
          '(' +
          this.selectedCusip +
          ') is not in the proper format ' +
          '(row ' +
          this.formattedRangeOfRowNumbers(this.invalidCusipCellsArray) +
          ')',
      ]);
    } else if (this.isCellWithOfaceInvalid && this.invalidOfaceCellsArray.length > 0) {
      this.genericErrorMesasgesList.push([
        StringConstants.ANALYZER_SHOW_OFACE_COLUMN_INVALID_FORMAT_ERROR_MESSAGE +
          '(' +
          this.selectedOface +
          ') is not in the proper format ' +
          '(row ' +
          this.formattedRangeOfRowNumbers(this.invalidOfaceCellsArray) +
          ')',
      ]);
    }

    if (this.isOfaceLessThan1000 && this.ofaceLessThan1000CellsArray.length > 0) {
      this.genericErrorMesasgesList.push([
        StringConstants.ANALYZER_SHOW_OFACE_COLUMN_INVALID_FORMAT_ERROR_MESSAGE +
          '(' +
          this.selectedOface +
          ') must be >= $1000 ' +
          '(row ' +
          this.formattedRangeOfRowNumbers(this.ofaceLessThan1000CellsArray) +
          ')',
      ]);
    }

    if (
      this.validateCollateralReq !== null &&
      this.validateCollateralReq.length > 0 &&
      !this.hasFileLevelErrors &&
      !this.isCellWithCusipInvalid &&
      !this.isCellWithOfaceInvalid &&
      !this.isOfaceLessThan1000
    ) {
      this.validationCall(this.validateCollateralReq);
    } else {
      this.hasFileLevelErrors = true;
      this.hasValidationErrors = false;
      this.showInitialScreen = true;
      this.showBannerErrorMsg = StringConstants.ANALYZER_SHOW_BANNER_ERROR_MESSAGE;
      this.fmLoadingPageService.isLoaderRequesting.set(false);
    }
  }

  public formattedRangeOfRowNumbers(rows) {
    const ranges = [];
    let rstart;
    let rend;
    for (let i = 0; i < rows.length; i++) {
      rstart = rows[i];
      rend = rstart;
      while (rows[i + 1] - rows[i] === 1) {
        rend = rows[i + 1];
        i++;
      }
      ranges.push(rstart === rend ? rstart + '' : rstart + '-' + rend);
    }
    return ranges;
  }

  public resetCellsForCUSIPAndOface() {
    this.isCusipColumnEmpty = false;
    this.isOfaceColumnEmpty = false;
    this.isCellEmpty = false;
    this.isCellWithCusipInvalid = false;
    this.isCellWithOfaceInvalid = false;
    this.isOfaceLessThan1000 = false;
    this.genericErrorMesasgesList = [];
    this.emptyCellsArray = [];
    this.invalidCusipCellsArray = [];
    this.invalidOfaceCellsArray = [];
    this.ofaceLessThan1000CellsArray = [];
  }

  private buildCollateralValidationRequest(
    mBundle,
    index,
    jsonRow,
    cusipIndex,
    ofaceIndex,
    headerExists: boolean,
  ) {
    mBundle.isAddOrEdit = 'N';
    mBundle.rowNumber = index === 0 ? 1 : index + 1;
    mBundle.cusip = !isNullOrUndefined(jsonRow[cusipIndex])
      ? /^[a-zA-Z0-9]+$/.test(jsonRow[cusipIndex])
        ? jsonRow[cusipIndex].length === 9
          ? jsonRow[cusipIndex]
          : 'invalid-input'
        : 'invalid-input'
      : null;
    mBundle.contribOrigFace = !isNullOrUndefined(jsonRow[ofaceIndex])
      ? /^[$]?([0-9]{1,3}?[,]?)*[0-9]{1,3}?[.]?[0-9]*?$/.test(jsonRow[ofaceIndex])
        ? this.formatAmount(jsonRow[ofaceIndex]) !== 'invalid-input'
          ? this.formatAmount(jsonRow[ofaceIndex]) >= 1000
            ? this.formatAmount(jsonRow[ofaceIndex])
            : 'less-than-1000'
          : 'invalid-input'
        : 'invalid-input'
      : null;
    mBundle.isAddOrEdit = 'N';
    if (
      !isNullOrUndefined(mBundle.cusip) &&
      mBundle.cusip !== 'invalid-input' &&
      !isNullOrUndefined(mBundle.contribOrigFace) &&
      mBundle.contribOrigFace !== 'invalid-input' &&
      mBundle.contribOrigFace !== 'less-than-1000'
    ) {
      if (headerExists && index !== 0) {
        this.validateCollateralReq.push(mBundle);
      } else {
        this.validateCollateralReq.push(mBundle);
      }
    } else if (isNullOrUndefined(mBundle.cusip) && isNullOrUndefined(mBundle.contribOrigFace)) {
      this.isEmptyRow = true;
      if (index === 0) {
        this.isHeaderasFirstRowExits = false;
      }
    } else if (
      mBundle.cusip === 'invalid-input' &&
      mBundle.contribOrigFace === 'invalid-input' &&
      index === 0 &&
      headerExists
    ) {
      this.isEmptyRow = true;
    } else if (
      mBundle.cusip === 'invalid-input' &&
      mBundle.contribOrigFace === 'invalid-input' &&
      index !== 0 &&
      headerExists &&
      !this.isHeaderasFirstRowExits
    ) {
      this.isEmptyRow = true;
      this.isHeaderasFirstRowExits = true;
    } else {
      this.hasFileLevelErrors = true;
      if (isNullOrUndefined(mBundle.cusip) || isNullOrUndefined(mBundle.contribOrigFace)) {
        this.isCellEmpty = true;
        this.emptyCellsArray.push(mBundle.rowNumber);
      }

      if (mBundle.cusip === 'invalid-input' && mBundle.contribOrigFace === 'invalid-input') {
        this.isCellWithCusipInvalid = true;
        this.isCellWithOfaceInvalid = true;
        this.invalidOfaceCellsArray.push(mBundle.rowNumber);
        this.invalidCusipCellsArray.push(mBundle.rowNumber);
      } else if (mBundle.cusip === 'invalid-input' && (index !== 0 || !headerExists)) {
        this.isCellWithCusipInvalid = true;
        this.invalidCusipCellsArray.push(mBundle.rowNumber);
      } else if (mBundle.contribOrigFace === 'invalid-input' && (index !== 0 || !headerExists)) {
        this.isCellWithOfaceInvalid = true;
        this.invalidOfaceCellsArray.push(mBundle.rowNumber);
      }
      if (mBundle.contribOrigFace === 'less-than-1000' && (index !== 0 || !headerExists)) {
        this.isOfaceLessThan1000 = true;
        this.ofaceLessThan1000CellsArray.push(mBundle.rowNumber);
      }
    }
  }

  public formatAmount(amount): any {
    let formatAmount = 0;
    let amountWithPricision = '0.00';
    amount = amount.toString().replace('$', '').replace(/\,/g, '');
    amountWithPricision = parseFloat(amount).toFixed(2);
    const decimalSplit = amountWithPricision.split('.');
    if (decimalSplit[1] === '00') {
      formatAmount = parseInt(amountWithPricision, 10);
      return formatAmount;
    } else {
      return 'invalid-input';
    }
  }

  public handlevalidateCollateralServiceSuccess(res: any) {
    this.collateralValidatedPoolListRes = res;
    this.displaySucessMessage = this.deleteFlow
      ? '(' + this.deletedRowCount + ') Collateral Removed'
      : this.editFlow
        ? 'Edits Saved'
        : this.addFlow
          ? '(1) Collateral Added'
          : 'Collateral Uploaded';

    this.displaySucessHeader = 'Success!';
    this.validatedCollateralPoolCount =
      this.collateralValidatedPoolListRes &&
      this.collateralValidatedPoolListRes.collateralDetails &&
      this.collateralValidatedPoolListRes.collateralDetails.length;
    this.collateralValidatedPoolList =
      this.collateralValidatedPoolListRes && this.collateralValidatedPoolListRes.collateralDetails;
    this.megaDetailsList =
      this.collateralValidatedPoolListRes && this.collateralValidatedPoolListRes.megaDetails;
    this.freddieIssued =
      this.megaDetailsList &&
      (this.megaDetailsList.freddiupbAmountWithFactor / this.megaDetailsList.dealAmount) * 100;
    this.fannieIssued = 100 - this.freddieIssued;
    this.WAMonthsToMaturity = this.megaDetailsList && this.megaDetailsList.monthsToMaturity;
    this.netInterestRate = this.megaDetailsList && this.megaDetailsList.coupon;
    this.displayFileDataSelectionPopup = false;
    this.deleteFlow = false;
    this.editFlow = false;
    this.addFlow = false;
    this.passDataService.setAnalyzerValidatedCollateralResponse(res);
    this.passDataService.setCollateralCUSIPList(res.collateralDetails);
    if (
      isNullOrUndefined(
        this.collateralValidatedPoolListRes &&
          this.collateralValidatedPoolListRes.collateralDetails,
      )
    ) {
      this.hasValidationErrors = true;
      this.showInitialScreen = true;
      this.validationErrorList = this.collateralValidatedPoolListRes.validationErrors;
      this.compositeErrorList = this.collateralValidatedPoolListRes.compositeErrorMessage;
      this.genericErrorMesasgesList = this.collateralValidatedPoolListRes.genericErrorMessages;
      this.showBannerErrorMsg = StringConstants.ANALYZER_SHOW_BANNER_ERROR_MESSAGE;
    } else {
      this.showInitialScreen = false;
      this.showAddCollateralPopup = false;
      this.showCollateralUploadSucessMessage = true;
      this.showAnalyzerGrid = true;
      this.showAnalyzerDetails = false;
      this.showAnalyzerStatistics = false;
      this.retainChangeTabSelection();
      this.tabName = this.passDataService.getAnalyzerUploadedFileSheetName();
      this.collateralValidatedPoolList.forEach((item) => {
        item.isSelected = false;
      }, this);
      this.setFeatureToggle();
      this.updateValidationRequest();
      setTimeout(
        function () {
          this.showCollateralUploadSucessMessage = false;
        }.bind(this),
        3000,
      );

      this.closeMessageBanner();
    }
    this.selectedRowsForDeletion = [];
    this.validateCollateralClicked = true;
    this.fmLoadingPageService.isLoaderRequesting.set(false);
    this.cdr.markForCheck();
  }

  public handlevalidateCollateralServiceFail(error: any): void {
    this.displayFileDataSelectionPopup = false;
    this.disableAddCollateralButton = true;
    this.validateCollateralClicked = true;
    this.fmLoadingPageService.isLoaderRequesting.set(false);
    this.addLinkClicked = true;
    this.editLinkClicked = true;
    this.analyzerDisclosureService.handleAnalyzerGrid500ErrorCode(error);
    this.cdr.markForCheck();
  }

  handleReplaceFile() {
    this.showInitialScreen = true;
    this.displayCancelCollateralPopup = false;
    this.analyzerIntroDisclosureText = StringConstants.ANALYZER_INTRO_DISCLOSURE_TEXT;
    this.analyzerIntroFactorsText = StringConstants.ANALYZER_INTRO_FACTORS_TEXT;
    this.analyzerIntroAsteriskText = StringConstants.ANALYZER_INTRO_ASTERISK_TEXT;
    this.passDataService.setGoBackEditFlag(null);
    this.closeMessageBanner();
  }

  public checkFactorData(): void {
    this.megaService.checkFactorData().subscribe({
      next: (data) => this.handleCheckFactorDataMegaServiceSuccess(data),
      error: (error) => this.handleCheckFactorDataMegaServiceFail(error),
    });
  }

  private handleCheckFactorDataMegaServiceSuccess(factorsdata) {
    this.checkFactorDataAvailable = factorsdata;
    this.fmLoadingPageService.isLoaderRequesting.set(false);
    this.cdr.markForCheck();
  }

  private handleCheckFactorDataMegaServiceFail(error: any): void {
    this.analyzerDisclosureService.handleAnalyzerGrid500ErrorCode(error);
    this.fmLoadingPageService.isLoaderRequesting.set(false);
    this.cdr.markForCheck();
  }

  public hideEditCollateralPopup(): void {
    this.cusipFormatErrors = [];
    this.ofaceFormatErrors = [];
    this.showEditCollateralPopup = false;
    this.editFlow = false;
  }

  public handleDeleteSelected(): any {
    this.fmLoadingPageService.isLoaderRequesting.set(true);

    const updatedReqFromDelete = [];
    let collateralValidatedPoolListTemp: any;
    this.deleteFlow = true;
    collateralValidatedPoolListTemp = this.collateralValidatedPoolList;
    collateralValidatedPoolListTemp.forEach((item, index) => {
      item.indexVal = index;
    });

    this.deletedRowCount = this.selectedRowsForDeletion && this.selectedRowsForDeletion.length;

    this.selectedRowsForDeletion.forEach((obj) => {
      collateralValidatedPoolListTemp = collateralValidatedPoolListTemp.filter(
        (item) => item.indexVal !== obj.indexPos,
      );
    });
    this.validatedCollateralPoolCount = collateralValidatedPoolListTemp.length;

    collateralValidatedPoolListTemp.forEach(function (item, index) {
      const mBundle: any = {};
      mBundle.rowNumber = index + 1;
      mBundle.cusip = item.cusip;
      mBundle.contribOrigFace = item.upbAmount;
      mBundle.isAddOrEdit = 'N';
      updatedReqFromDelete.push(mBundle);
    });
    this.selectedRowsForDeletion = [];
    this.displayDeleteCollateralPopup = false;
    this.enableDeleteButton = false;
    this.validationCall(updatedReqFromDelete);
  }

  public handleDeleteAll(): any {
    const deleteAllCollateralCount =
      this.collateralValidatedPoolList && this.collateralValidatedPoolList.length;
    this.displayDeleteAllCollateralPopup = false;
    this.showInitialScreen = true;
    this.displayDeleteAllSucessHeader = 'Success!';
    this.displayDeleteAllSucessMessage = '(' + deleteAllCollateralCount + ') Collateral Removed';
    this.showDeleteAllSucessMessage = true;
    setTimeout(
      function () {
        this.showDeleteAllSucessMessage = false;
      }.bind(this),
      3000,
    );

    this.closeMessageBanner();
  }

  handleDeleteSelectedRows(poolListForDelete: any) {
    this.isDeleteAllSelected = false;
    const tempPoolListForDelete = poolListForDelete;
    this.selectedRowsForDeletion = [];

    tempPoolListForDelete.poolListForDelete.forEach((item, index) => {
      if (item.isSelected) {
        this.selectedRowsForDeletion.push({ cusip: item.cusip, indexPos: index });
      }
    }, this);

    if (tempPoolListForDelete.poolListForDelete.every((element) => element.isSelected === true)) {
      this.isDeleteAllSelected = true;
    }

    this.enableDeleteButton =
      this.selectedRowsForDeletion && this.selectedRowsForDeletion.length > 0 ? true : false;
  }

  handleDeleteAllRows(deleteAllCusip: any) {
    this.isDeleteAllSelected = deleteAllCusip.deleteAllCusip ? true : false;

    this.enableDeleteButton = deleteAllCusip.deleteAllCusip ? true : false;
  }

  public getSettlementDate(megaType: string): void {
    this.showCalendarBusyIndicator = true;
    this.cdr.markForCheck();
    this.megaTypeVal = megaType;
    const settleDateInfoMegaRequest: any = {};
    settleDateInfoMegaRequest.megaType = megaType;

    settleDateInfoMegaRequest.poolNumber = null;
    settleDateInfoMegaRequest.isCollateralAnalyzer = true;

    this.megaService
      .settlementDate(settleDateInfoMegaRequest)
      .pipe(finalize(() => this.clearCalendarBusyIndicator()))
      .subscribe({
        next: (data) => this.handelSettlementDateServiceSuccess(data as any),
        error: (error) => this.handleSettlementDateServiceFail(error),
      });
  }

  public handelSettlementDateServiceSuccess(settlementDate: any) {
    this.clearCalendarBusyIndicator();
    const startDateArray = settlementDate.startDate.split('-');
    const startDate = new Date(startDateArray[0], Number(startDateArray[1]) - 1, startDateArray[2]);

    const endDateArray = settlementDate.endDate.split('-');
    const endDate = new Date(Number(endDateArray[0]) - 1, Number(endDateArray[1]), Number(1));

    this.populateMegaSettlementDates(startDate, endDate, settlementDate.exclusions);
    this.cdr.markForCheck();
  }

  public populateMegaSettlementDates(sDate: Date, eDate: Date, exclusions: Array<string>): void {
    this.collateralAnalyzerSettlemntDateOptions = {
      firstDayOfWeek: 'su',
      satHighlight: false,
      sunHighlight: false,
      disableWeekends: true,
      showFooterToday: false,
      disableUntil: {
        year: sDate.getFullYear(),
        month: sDate.getMonth() + 1,
        day: sDate.getDate(),
      },
      disableSince: {
        year: eDate.getFullYear(),
        month: eDate.getMonth() + 1,
        day: eDate.getDate(),
      },
      disableDates: this.extractExclusionDates(exclusions),
    };
  }

  public extractExclusionDates(dateExclusions: Array<string>): Array<any> {
    const exclusionDates: Array<any> = new Array<any>();

    dateExclusions = this.removeDateTimestamp(dateExclusions);

    for (const dateExclusion of dateExclusions) {
      const convertedDateArray = dateExclusion.split('-');
      const convertedDate = new Date(
        Number(convertedDateArray[0]),
        Number(convertedDateArray[1]) - 1,
        Number(convertedDateArray[2]),
      );
      exclusionDates.push({
        year: convertedDate.getFullYear(),
        month: convertedDate.getMonth() + 1,
        day: convertedDate.getDate(),
      });
    }

    return exclusionDates;
  }

  public handleSettlementDateServiceFail(error: any): void {
    this.analyzerDisclosureService.handleAnalyzerGrid500ErrorCode(error);
    this.clearCalendarBusyIndicator();
    this.cdr.markForCheck();
  }

  private clearCalendarBusyIndicator(): void {
    this.showCalendarBusyIndicator = false;
    this.cdr.markForCheck();
  }

  public getCalculateFee(): void {
    this.hideCreateMegaPopup();
    this.fmLoadingPageService.isLoaderRequesting.set(true);
    const mBundle: any = {};
    mBundle.megaType = this.megaTypeVal;
    mBundle.prefixCode = this.megaDetailsList.megaPrefix;
    const freddieIssuedAmt: number = this.megaDetailsList.freddiupbAmountWithFactor;
    mBundle.freddieIssuedAmt = freddieIssuedAmt;
    mBundle.hasFreddieCollateral = freddieIssuedAmt > 0 ? true : false;
    if (this.megaTypeVal === 'SFFIXMEGA') {
      mBundle.tradeAmount = Number(this.megaDetailsList.dealAmount);
      const mSfTradeSettlementDate = moment(this.dateSelected).format('YYYY-MM-DD');
      mBundle.tradeSettlementDate = mSfTradeSettlementDate.toString();
      mBundle.sfFixedCoupon = this.megaDetailsList.coupon;
    }
    if (this.megaTypeVal === 'SFARMMEGA') {
      mBundle.tradeAmount = Number(this.megaDetailsList.dealAmount);
      const mSfArmTradeSettlementDate = moment(this.dateSelected).format('YYYY-MM-DD');
      mBundle.tradeSettlementDate = mSfArmTradeSettlementDate.toString();
      mBundle.sfARMSubType =
        this.megaDetailsList.subType && this.megaDetailsList.subType.toUpperCase();
    }
    if (this.megaTypeVal === 'MFFIXMEGA') {
      mBundle.tradeAmount = Number(this.megaDetailsList.dealAmount);
      const mMfFixTradeSettlementDate = moment(this.dateSelected).format('YYYY-MM-DD');
      mBundle.tradeSettlementDate = mMfFixTradeSettlementDate.toString();
      mBundle.mfHighCoupon = this.megaDetailsList.mfHighCoupon;
      mBundle.mfLowCoupon = this.megaDetailsList.mfLowCoupon;
    }

    if (this.megaTypeVal === 'MFARMMEGA') {
      mBundle.tradeAmount = Number(this.megaDetailsList.dealAmount);
      const mMfArmTradeSettlementDate = moment(this.dateSelected).format('YYYY-MM-DD');
      mBundle.tradeSettlementDate = mMfArmTradeSettlementDate.toString();
      mBundle.sfARMSubType =
        this.megaDetailsList.subType && this.megaDetailsList.subType.toUpperCase();
    }

    mBundle.poolNumber = null;

    this.calcFeeRequest = mBundle;

    if (this.viewFeesButtonClicked) {
      this.megaService.calculateFee(this.calcFeeRequest).subscribe({
        next: (data) => this.handelCalculateFeeServiceSuccess(data),
        error: (error) => this.handleAWSCalculateFeeServiceFail(error),
      });
    }
    this.viewFeesButtonClicked = false;
  }

  public handelCalculateFeeServiceSuccess(calcFee: any) {
    this.fmLoadingPageService.isLoaderRequesting.set(false);
    this.viewFeesButtonClicked = true;
    this.passDataService.setCalculateFeeMegaResponse(calcFee);
    this.passDataService.setMegaType(this.megaTypeVal);
    this.cdr.markForCheck();
    this.router.navigate(['collateral-analyzer/review-and-commit']);
  }

  public handleAWSCalculateFeeServiceFail(error: any): void {
    this.fmLoadingPageService.isLoaderRequesting.set(false);
    this.viewFeesButtonClicked = true;
    this.analyzerDisclosureService.handleAnalyzerGrid500ErrorCode(error);
    this.cdr.markForCheck();
  }

  private onInitTooltipMessage(): void {}

  public handleReplaceFileShowMessage(): void {
    this.cancelUploadCollateralInfoText =
      'By replacing the uploaded collateral file, all data currently displayed will be removed.';
    this.cancelPopUpTitle = 'Upload New Collateral File';
    this.cancelButtonLabel = 'Yes, Replace';
    this.displayCancelCollateralPopup = true;
  }

  public hideCancelCollateralPopup(): void {
    this.displayCancelCollateralPopup = false;
  }

  public hideDeleteCollateralPopup(): void {
    this.displayDeleteCollateralPopup = false;
  }

  public hideDeleteAllCollateralPopup(): void {
    this.displayDeleteAllCollateralPopup = false;
  }

  public showDeleteConfirmPopup(): void {
    if (this.isDeleteAllSelected) {
      this.deleteAllCollateralInfoText = StringConstants.COLLATERAL_ANALYZER_DELETE_ALL_MESSAGE;
      this.displayDeleteAllCollateralPopup = true;
    } else {
      this.deleteCollateralInfoText = StringConstants.COLLATERAL_ANALYZER_DELETE_MESSAGE;
      this.displayDeleteCollateralPopup = true;
    }
  }

  public closeSuccessMessageBanner(): void {
    this.showCollateralUploadSucessMessage = false;
  }

  public generateExcel(): void {
    this.downloadXlsx.generateExcel(this.collateralValidatedPoolListRes);
  }

  private validateNumber(): ValidatorFn {
    return (control: UntypedFormControl): { [key: string]: boolean } => {
      if (control.value < 1000) {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        return { DealAmount_less_than_one_thousand: false };
      } else {
        return null;
      }
    };
  }

  public validateDealAmount(ctl: UntypedFormControl) {
    if (ctl.value < 1000) {
      this.isDealAmtLessThanOneThousand = true;
    } else {
      this.isDealAmtLessThanOneThousand = false;
    }
  }

  public handleValidateCollateralReqFromExcel(event): void {
    let reqFromExcel: any = {};
    reqFromExcel = event && event.excelReq;

    this.fmLoadingPageService.isLoaderRequesting.set(true);

    this.validationCall(reqFromExcel);
  }

  public validationCall(collateralReq): any {
    const req: any = {};

    req.poolDetails = collateralReq;
    if (this.validateCollateralClicked) {
      this.megaService.collateralAnalyzerValidateCollateral(req).subscribe({
        next: (data) => this.handlevalidateCollateralServiceSuccess(data),
        error: (error) => this.handlevalidateCollateralServiceFail(error),
      });
    }

    this.validateCollateralClicked = false;
  }

  public addValuechange(event): void {
    this.disableAddCollateralButton = true;
    const field: string = event.srcElement.name;
    const value = event.srcElement.value;

    if (field === 'cusip') {
      switch (this.checkCusipFormat(value)) {
        case 'invalid-input': {
          this.cusipFormatErrors = [];
          this.cusipFormatErrors.push(StringConstants.ANALYZER_CUSIP_FORMAT_ERROR);
          this.showCusipFormatError = true;
          this.disableAddCollateralButton = true;
          this.businessValidationErrors = false;
          break;
        }
        default: {
          this.cusipFormatErrors = [];
          this.showCusipFormatError = false;
          this.cusipAddInput = value;
        }
      }
    } else if (field === 'oface') {
      const fMat = this.checkOFaceFormat(value);
      switch (fMat) {
        case 'invalid-input': {
          this.ofaceFormatErrors = [];
          this.ofaceFormatErrors.push(StringConstants.ANALYZER_OFACE_FORMAT_ERROR);
          this.disableAddCollateralButton = true;
          this.showOfaceFormatError = true;
          this.businessValidationErrors = false;
          break;
        }
        case 'less-than-1000': {
          this.ofaceFormatErrors = [];
          this.ofaceFormatErrors.push(StringConstants.ANALYZER_OFACE_LESS_THAN_1000_FORMAT_ERROR);
          this.disableAddCollateralButton = true;
          this.showOfaceFormatError = true;
          this.businessValidationErrors = false;
          break;
        }
        default: {
          this.ofaceFormatErrors = [];
          this.showOfaceFormatError = false;
          this.oFaceAddInput = this.currencyTransform(
            value.replace('$', '').replace(',', '').replace(/\,/g, ''),
          );
          break;
        }
      }
    }
    if (this.cusipAddInput !== '' && this.oFaceAddInput !== '') {
      if (this.ofaceFormatErrors.length === 0 && this.cusipFormatErrors.length === 0) {
        this.disableAddCollateralButton = false;
      } else if (this.businessValidationErrors) {
        this.cusipFormatErrors = [];
        this.ofaceFormatErrors = [];
        this.showCusipFormatError = false;
        this.showOfaceFormatError = false;
        this.disableAddCollateralButton = false;
      } else {
        this.disableAddCollateralButton = true;
      }
    }
  }

  public addCollateral() {
    this.validateCollateralEditReq = [];
    this.disableAddCollateralButton = true;
    const req: any = {};
    let reqPoolDetails: any = {};
    reqPoolDetails.rowNumber = 1;
    reqPoolDetails.cusip = this.cusipAddInput && this.cusipAddInput.trim();
    reqPoolDetails.contribOrigFace = Number(
      this.oFaceAddInput.replace('$', '').replace(',', '').replace(/\,/g, ''),
    );
    reqPoolDetails.isAddOrEdit = 'Y';
    this.validateCollateralEditReq.push(reqPoolDetails);

    for (let i = 0; i < this.validateCollateralReq.length; i++) {
      reqPoolDetails = {};
      reqPoolDetails.rowNumber = i + 2;
      reqPoolDetails.cusip = this.validateCollateralReq[i].cusip;
      reqPoolDetails.contribOrigFace = this.validateCollateralReq[i].contribOrigFace;
      reqPoolDetails.isAddOrEdit = 'N';
      this.validateCollateralEditReq.push(reqPoolDetails);
    }
    this.addFlow = true;
    req.poolDetails = this.validateCollateralEditReq;
    if (this.addLinkClicked) {
      this.megaService.collateralAnalyzerValidateCollateral(req).subscribe({
        next: (data) => this.addEditCollateralValidationSuccess(data),
        error: (error) => this.handlevalidateCollateralServiceFail(error),
      });
    }

    this.addLinkClicked = false;
  }

  currencyTransform(value: string, fractionSize: number = 0): string {
    if (parseFloat(value) % 1 !== 0) {
      fractionSize = 2;
    }
    let [integer, fraction = ''] = (parseFloat(value).toString() || '').toString().split('.');

    fraction =
      fractionSize > 0
        ? this.decimalSeparator + (fraction + padding).slice(0, Math.max(0, fractionSize))
        : '';
    integer = integer.replace(/\B(?=(\d{3})+(?!\d))/g, this.thousandsSeparator);
    if (isNaN(parseFloat(integer))) {
      integer = '0';
    }
    return this.prefix + integer + fraction + this.suffix;
  }

  parse(value: string, fractionSize: number = 2): string {
    let [integer, fraction = ''] = (value || '')
      .replace(this.prefix, '')
      .replace(this.suffix, '')
      .split(this.decimalSeparator);

    integer = integer.replace(new RegExp(this.thousandsSeparator, 'g'), '');

    fraction =
      parseInt(fraction, 10) > 0 && fractionSize > 0
        ? this.decimalSeparator + (fraction + padding).slice(0, Math.max(0, fractionSize))
        : '';

    return integer + fraction;
  }

  public updateValidationRequest(): any {
    this.validateCollateralReq = [];
    this.collateralValidatedPoolList.forEach((item, index) => {
      const reqPoolDetails: any = {};
      reqPoolDetails.rowNumber = index + 1;
      reqPoolDetails.cusip = item.cusip;
      reqPoolDetails.contribOrigFace = item.upbAmount;
      reqPoolDetails.isAddOrEdit = 'N';
      this.validateCollateralReq.push(reqPoolDetails);
    }, this);

    this.LDshowDisclosureDetails =
      this.collateralValidatedPoolListRes.megaType === 'MFFIXMEGA' ||
      this.collateralValidatedPoolListRes.megaType === 'MFARMMEGA'
        ? false
        : this.LDshowDisclosureDetails;

    if (this.LDshowDisclosureDetails) {
      this.enablePDFButton = false;
      this.analyzerDetailsTabError = false;
      this.analyzerStatisticsTabError = false;
      if (this.passDataService.getGoBackEditFlag() !== 'true') {
        this.analyzerDisclosureService.disclosureDetailsReset();
        this.disclosureDetailsResetBeforeCall();
        this.analyzerDisclosureService.getDisclosure();
      } else {
        this.analyzerDetailsTabError = this.passDataService.getAnalyzerDetailsTmpMegaError();
        this.analyzerStatisticsTabError = this.passDataService.getAnalyzerStatisticsTmpMegaError();
        this.enablePDFButton = this.passDataService.getDisclosurePDFButton();
        this.readDataFromDataService();
      }
    } else {
      this.showAnalyzerStatistics = false;
      this.showAnalyzerDetails = false;
      this.enablePDFButton = true;
    }
  }

  public generatePdf(): void {
    this.fmLoadingPageService.isLoaderRequesting.set(true);

    const pdfBundle: any = {};
    pdfBundle.gridData = this.collateralValidatedPoolListRes;
    pdfBundle.showDisclosure = false;

    if (this.LDshowDisclosureDetails) {
      pdfBundle.showDisclosure = true;
      pdfBundle.analyzerDetailsTabError = this.analyzerDetailsTabError;
      pdfBundle.analyzerStatisticsTabError = this.analyzerStatisticsTabError;
      pdfBundle.waDetailsRes = this.passDataService.getDisclosureWaDetailsRes();
      pdfBundle.sellerDetailsRes = this.passDataService.getDisclosureSellerDetailsRes();
      pdfBundle.detailsMonthsToMaturity = this.WAMonthsToMaturity;
      pdfBundle.detailsNetInterestRate = this.netInterestRate;
      pdfBundle.loanPurposeRes = this.passDataService.getLoanPurposeRes();
      pdfBundle.propertyTypeRes = this.passDataService.getPropertyTypeRes();
      pdfBundle.channelRes = this.passDataService.getChannelRes();
      pdfBundle.occupancyStatusRes = this.passDataService.getoccupancyStatusRes();
      pdfBundle.stateRes = this.passDataService.getStateRes();

      pdfBundle.borrowerRes = this.passDataService.getBorrowersRes();
      pdfBundle.mtgInsuranceCancelIndRes = this.passDataService.getMortgageInsCancelIndRes();
      pdfBundle.mtgInsuranceCoverageRes = this.passDataService.getMortgageInsCoverageRes();
      pdfBundle.numberOfUnitsRes = this.passDataService.getNumberOfUnitsRes();
      pdfBundle.originationYearRes = this.passDataService.getOriginationYearRes();
      pdfBundle.servicerDistributionRes = this.passDataService.getServicersLessThanOnePercentRes();

      pdfBundle.quartileCompleteRes = this.passDataService.getQuartileCompleteRes();

      if (this.analyzerDetailsTabError && this.analyzerStatisticsTabError) {
        pdfBundle.showDisclosure = false;
      }
    }

    this.downloadPdfService.downloadPDF(pdfBundle);
    this.fmLoadingPageService.isLoaderRequesting.set(false);
  }

  public retainChangeTabSelection(): void {
    this.passDataService.setDropDownSelectedCusip(this.selectedCusip);
    this.passDataService.setDropDownSelectedOface(this.selectedOface);
    this.passDataService.setAnalyzerUploadedFileSheetName(this.selectedSheet);
    this.passDataService.setIsHeaderChecked(this.hasHeaderRow);
  }

  public showDetailsSection(type): void {
    this.showAnalyzerGrid = type === 'collateral' ? true : false;
    this.showAnalyzerDetails = type === 'details' ? true : false;
    this.showAnalyzerStatistics = type === 'statistics' ? true : false;
  }

  public setFeatureToggle(): void {
    if (!isNullOrUndefined(this.userService)) {
      this.featuretoggle = this.userService.toggleFeatures;
    }

    if (
      this.featuretoggle &&
      this.featuretoggle.includes(FeatureFlag.ANALYZER_DISCLOSURE_DETAILS)
    ) {
      this.LDshowDisclosureDetails = true;
    }
  }

  public displaydisclosureDetails(): void {
    this.analyzerDisclosureService.analyzerDisclosureSubscription$.subscribe((data) => {
      this.disclosureWaDetailsRes = data.disclosureWaDetailsRes;
      this.disclosureSellerDetailsRes = data.disclosureSellerDetailsRes;
      this.loanPurposeRes = data.loanPurposeRes;
      this.propertyTypeRes = data.propertyTypeRes;
      this.channelRes = data.channelRes;
      this.occupancyStatusRes = data.occupancyStatusRes;
      this.numberOfUnitsRes = data.numberOfUnitsRes;
      this.originationYearRes = data.originationYearRes;
      this.stateRes = data.stateRes;
      this.servicersRes = data.servicersRes;
      this.borrowersRes = data.borrowersRes;
      this.mortgageInsCancelIndRes = data.mortgageInsCancelIndRes;
      this.mortgageInsCoverageRes = data.mortgageInsCoverageRes;

      this.mortgageLoanAmountQuartileRes = data.mortgageLoanAmountQuartileRes;
      this.interestRateQuartileRes = data.interestRateQuartileRes;
      this.netInterestRateCurrentQuartileRes = data.netInterestRateCurrentQuartileRes;
      this.loanTermQuartileRes = data.loanTermQuartileRes;
      this.loanAgeQuartileRes = data.loanAgeQuartileRes;
      this.loanToValueQuartileRes = data.loanToValueQuartileRes;
      this.combinedLoanToValueQuartileRes = data.combinedLoanToValueQuartileRes;
      this.borrowerCreditScoreQuartileRes = data.borrowerCreditScoreQuartileRes;
      this.remainingMonthsToMaturityQuartileRes = data.remainingMonthsToMaturityQuartileRes;
      this.readDataFromDataService();

      this.servicersDetailsPDFResolved();
      this.showQuartileResResolved();
    });
  }

  public disclosureDisplayPDFButton(): void {
    this.analyzerDisclosureService.disclosurePDFButtonCodeSubscription$.subscribe((data) => {
      if (data === 'deleteTempMegaResolve') {
        this.enablePDFButton = true;
        this.passDataService.setDisclosurePDFButton(this.enablePDFButton);
      }
    });
  }

  public readDataFromDataService(): any {
    if (!isNullOrUndefined(this.collateralAnalyzerDetailsComponent)) {
      this.collateralAnalyzerDetailsComponent.disclosureWaDetails(
        this.passDataService.getDisclosureWaDetailsRes(),
      );
      this.collateralAnalyzerDetailsComponent.disclosureSelleDetails(
        this.passDataService.getDisclosureSellerDetailsRes(),
      );
    }

    if (!isNullOrUndefined(this.collateralAnalyzerStatisticsComponent)) {
      this.collateralAnalyzerStatisticsComponent.loanPurposeDetailsResolved(
        this.passDataService.getLoanPurposeRes(),
      );
      this.collateralAnalyzerStatisticsComponent.propertyTypeDetailsResolved(
        this.passDataService.getPropertyTypeRes(),
      );
      this.collateralAnalyzerStatisticsComponent.channelDetailsResolved(
        this.passDataService.getChannelRes(),
      );
      this.collateralAnalyzerStatisticsComponent.occupancyStatusDetailsResolved(
        this.passDataService.getoccupancyStatusRes(),
      );
      this.collateralAnalyzerStatisticsComponent.numberOfUnitsDetailsResolved(
        this.passDataService.getNumberOfUnitsRes(),
      );
      this.collateralAnalyzerStatisticsComponent.originationYearDetailsResolved(
        this.passDataService.getOriginationYearRes(),
      );
      this.collateralAnalyzerStatisticsComponent.stateDetailsResolved(
        this.passDataService.getStateRes(),
      );
      this.collateralAnalyzerStatisticsComponent.servicersDetailsResolved(
        this.passDataService.getServicersRes(),
      );
      this.collateralAnalyzerStatisticsComponent.borrowersDetailsResolved(
        this.passDataService.getBorrowersRes(),
      );
      this.collateralAnalyzerStatisticsComponent.mortgageInsCancelIndDetailsResolved(
        this.passDataService.getMortgageInsCancelIndRes(),
      );
      this.collateralAnalyzerStatisticsComponent.mortgageInsCoverageDetailsResolved(
        this.passDataService.getMortgageInsCoverageRes(),
      );
      this.collateralAnalyzerStatisticsComponent.showQuartileResResolved();
    }
  }

  public displayDisclosureErrorDetails(): void {
    this.analyzerDisclosureService.analyzerDisclosureDetailsTab500ErrorCodeSubscription$.subscribe(
      (error) => {
        this.handleDetailsTab500ErrorCode(error);
      },
    );

    this.analyzerDisclosureService.analyzerDisclosureWaDetailsTab500ErrorCodeSubscription$.subscribe(
      (error) => {
        this.handleWaDetailsTab500ErrorCode(error);
      },
    );

    this.analyzerDisclosureService.analyzerDisclosureSellerDetailsTab500ErrorCodeSubscription$.subscribe(
      (error) => {
        this.handleSellerDetailsTab500ErrorCode(error);
      },
    );

    this.analyzerDisclosureService.analyzerDisclosureStatisticsTab500ErrorCodeSubscription$.subscribe(
      (_data) => {
        this.handleStatisticsTab500ErrorCode();
      },
    );

    this.analyzerDisclosureService.analyzerDisclosureStatisticsTabLoanPurpose500ErrorCodeSubscription$.subscribe(
      (error) => {
        this.handleStatisticsTabLoanPurpose500ErrorCode(error);
      },
    );

    this.analyzerDisclosureService.analyzerDisclosureStatisticsTabOccupancyStatus500ErrorCodeSubscription$.subscribe(
      (error) => {
        this.handleStatisticsTabOccupancyStatus500ErrorCode(error);
      },
    );

    this.analyzerDisclosureService.analyzerDisclosureStatisticsTabChannel500ErrorCodeSubscription$.subscribe(
      (error) => {
        this.handleStatisticsTabChannel500ErrorCode(error);
      },
    );

    this.analyzerDisclosureService.analyzerDisclosureStatisticsTabState500ErrorCodeSubscription$.subscribe(
      (error) => {
        this.handleStatisticsTabState500ErrorCode(error);
      },
    );

    this.analyzerDisclosureService.analyzerDisclosureStatisticsTabPropertyType500ErrorCodeSubscription$.subscribe(
      (error) => {
        this.handleStatisticsTabPropertyType500ErrorCode(error);
      },
    );

    this.analyzerDisclosureService.analyzerDisclosureStatisticsTabBorrower500ErrorCodeSubscription$.subscribe(
      (error) => {
        this.handleStatisticsTabBorrower500ErrorCode(error);
      },
    );

    this.analyzerDisclosureService.analyzerDisclosureStatisticsTabInsuranceCancelInd500ErrorCodeSubscription$.subscribe(
      (error) => {
        this.handleStatisticsTabInsuranceCancelInd500ErrorCode(error);
      },
    );

    this.analyzerDisclosureService.analyzerDisclosureStatisticsTabInsuranceCoverage500ErrorCodeSubscription$.subscribe(
      (error) => {
        this.handleStatisticsTabInsuranceCoverage500ErrorCode(error);
      },
    );

    this.analyzerDisclosureService.analyzerDisclosureStatisticsTabUnits500ErrorCodeSubscription$.subscribe(
      (error) => {
        this.handleStatisticsTabUnits500ErrorCode(error);
      },
    );

    this.analyzerDisclosureService.analyzerDisclosureStatisticsTabOriginationYear500ErrorCodeSubscription$.subscribe(
      (error) => {
        this.handleStatisticsTabOriginationYear500ErrorCode(error);
      },
    );

    this.analyzerDisclosureService.analyzerDisclosureStatisticsTabServicerDistribution500ErrorCodeSubscription$.subscribe(
      (error) => {
        this.handleStatisticsTabServicerDistribution500ErrorCode(error);
      },
    );

    /*
     * Quartile call error handling
     */

    this.analyzerDisclosureService.disclosureStatisticsTabQuartilemortgageLoanAmount500ErrorCodeSubscription$.subscribe(
      (error) => {
        this.handleStatisticsTabQuartilemortgageLoanAmount500ErrorCode(error);
      },
    );

    this.analyzerDisclosureService.disclosureStatisticsTabQuartileinterestRate500ErrorCodeSubscription$.subscribe(
      (error) => {
        this.handleStatisticsTabQuartileinterestRate500ErrorCode(error);
      },
    );

    this.analyzerDisclosureService.disclosureStatisticsTabQuartilenetInterestRateCurrent500ErrorCodeSubscription$.subscribe(
      (error) => {
        this.handleStatisticsTabQuartilenetInterestRate500ErrorCode(error);
      },
    );

    this.analyzerDisclosureService.disclosureStatisticsTabQuartileloanTerm500ErrorCodeSubscription$.subscribe(
      (error) => {
        this.handleStatisticsTabQuartileloanTerm500ErrorCode(error);
      },
    );

    this.analyzerDisclosureService.disclosureStatisticsTabQuartileloanAge500ErrorCodeSubscription$.subscribe(
      (error) => {
        this.handleStatisticsTabQuartileloanAge500ErrorCode(error);
      },
    );

    this.analyzerDisclosureService.disclosureStatisticsTabQuartileloanToValue500ErrorCodeSubscription$.subscribe(
      (error) => {
        this.handleStatisticsTabQuartileloanToValue500ErrorCode(error);
      },
    );

    this.analyzerDisclosureService.disclosureStatisticsTabQuartilecombinedLoanToValue500ErrorCodeSubscription$.subscribe(
      (error) => {
        this.handleStatisticsTabQuartilecombinedLoanToValue500ErrorCode(error);
      },
    );

    this.analyzerDisclosureService.disclosureStatisticsTabQuartileborrowerCreditScore500ErrorCodeSubscription$.subscribe(
      (error) => {
        this.handleStatisticsTabQuartileborrowerCreditScore500ErrorCode(error);
      },
    );

    this.analyzerDisclosureService.disclosureStatisticsTabQuartileremainingMonthsToMaturity500ErrorCodeSubscription$.subscribe(
      (error) => {
        this.handleStatisticsTabQuartileremainingMonthsToMaturity500ErrorCode(error);
      },
    );
  }

  public handleDetailsTab500ErrorCode(error: any): void {
    if (error === 'details') {
      this.analyzerDisclosureErrorMsg = StringConstants.ANALYZER_DISCLOSURE_DATA_ERROR;
      this.analyzerDetailsTabError = true;
      this.enablePDFButton = true;
      this.passDataService.setDisclosurePDFButton(this.enablePDFButton);
      this.passDataService.setAnalyzerDetailsTmpMegaError(this.analyzerDetailsTabError);
    }
  }

  public handleWaDetailsTab500ErrorCode(error: any): void {
    if (error === 'waDetailsError') {
      this.passDataService.setDisclosureWaDetailsRes(null);
      this.analyzerDetailsError.push('showWaError');
      this.passDataService.setAnalyzerDetailsErrorIconVal('showWaError');
    }

    if (!isNullOrUndefined(this.collateralAnalyzerDetailsComponent)) {
      this.collateralAnalyzerDetailsComponent.handleDisclosureWaDetailsError(error);
    }

    this.showAllDetailsCallFailure();
  }

  public handleSellerDetailsTab500ErrorCode(error: any): void {
    if (error === 'sellerDetailsError') {
      this.passDataService.setDisclosureSellerDetailsRes(null);
      this.analyzerDetailsError.push('showSellerError');
      this.passDataService.setAnalyzerDetailsErrorIconVal('showSellerError');
    }

    if (!isNullOrUndefined(this.collateralAnalyzerDetailsComponent)) {
      this.collateralAnalyzerDetailsComponent.handleDisclosureSellerDetailsError(error);
    }

    this.showAllDetailsCallFailure();
  }

  public handleStatisticsTabLoanPurpose500ErrorCode(error: any): void {
    if (error === 'loanPurposeError') {
      this.analyzerStatisticsError.push('loanPurposeErrorDisplay');
      this.passDataService.setAnalyzerStatisticsErrorIconVal(this.analyzerStatisticsError);
      this.passDataService.setLoanPurposeRes(null);
    }

    if (!isNullOrUndefined(this.collateralAnalyzerStatisticsComponent)) {
      this.collateralAnalyzerStatisticsComponent.handleLoanPurposeError(error);
    }

    this.showAllStatisticsCallFailure();
  }

  public handleStatisticsTabOccupancyStatus500ErrorCode(error: any): void {
    if (error === 'occupancyStatusError') {
      this.analyzerStatisticsError.push('occupancyStatusErrorDisplay');
      this.passDataService.setAnalyzerStatisticsErrorIconVal(this.analyzerStatisticsError);
      this.passDataService.setoccupancyStatusRes(null);
    }

    if (!isNullOrUndefined(this.collateralAnalyzerStatisticsComponent)) {
      this.collateralAnalyzerStatisticsComponent.handleOccupancyStatusError(error);
    }
    this.showAllStatisticsCallFailure();
  }

  public handleStatisticsTabChannel500ErrorCode(error: any): void {
    if (error === 'channelError') {
      this.analyzerStatisticsError.push('channelErrorDisplay');
      this.passDataService.setAnalyzerStatisticsErrorIconVal(this.analyzerStatisticsError);
      this.passDataService.setChannelRes(null);
    }

    if (!isNullOrUndefined(this.collateralAnalyzerStatisticsComponent)) {
      this.collateralAnalyzerStatisticsComponent.handleChannelError(error);
    }
    this.showAllStatisticsCallFailure();
  }

  public handleStatisticsTabState500ErrorCode(error: any): void {
    if (error === 'stateError') {
      this.analyzerStatisticsError.push('stateErrorDisplay');
      this.passDataService.setAnalyzerStatisticsErrorIconVal(this.analyzerStatisticsError);
      this.passDataService.setStateRes(null);
    }

    if (!isNullOrUndefined(this.collateralAnalyzerStatisticsComponent)) {
      this.collateralAnalyzerStatisticsComponent.handleStateError(error);
    }
    this.showAllStatisticsCallFailure();
  }

  public handleStatisticsTabPropertyType500ErrorCode(error: any): void {
    if (error === 'propertyTypeError') {
      this.analyzerStatisticsError.push('propertyTypeErrorDisplay');
      this.passDataService.setAnalyzerStatisticsErrorIconVal(this.analyzerStatisticsError);
      this.passDataService.setPropertyTypeRes(null);
    }

    if (!isNullOrUndefined(this.collateralAnalyzerStatisticsComponent)) {
      this.collateralAnalyzerStatisticsComponent.handlePropertyTypeError(error);
    }
    this.showAllStatisticsCallFailure();
  }

  public handleStatisticsTabBorrower500ErrorCode(error: any): void {
    if (error === 'borrowerError') {
      this.analyzerStatisticsError.push('borrowerErrorDisplay');
      this.passDataService.setAnalyzerStatisticsErrorIconVal(this.analyzerStatisticsError);
      this.passDataService.setBorrowersRes(null);
    }

    if (!isNullOrUndefined(this.collateralAnalyzerStatisticsComponent)) {
      this.collateralAnalyzerStatisticsComponent.handleBorrowerError(error);
    }
    this.showAllStatisticsCallFailure();
  }

  public handleStatisticsTabInsuranceCancelInd500ErrorCode(error: any): void {
    if (error === 'insuranceCancelIndError') {
      this.analyzerStatisticsError.push('insuranceCancelIndErrorDisplay');
      this.passDataService.setAnalyzerStatisticsErrorIconVal(this.analyzerStatisticsError);
      this.passDataService.setMortgageInsCancelIndRes(null);
    }

    if (!isNullOrUndefined(this.collateralAnalyzerStatisticsComponent)) {
      this.collateralAnalyzerStatisticsComponent.handleInsuranceCancelIndError(error);
    }
    this.showAllStatisticsCallFailure();
  }

  public handleStatisticsTabInsuranceCoverage500ErrorCode(error: any): void {
    if (error === 'insuranceCoverageError') {
      this.analyzerStatisticsError.push('insuranceCoverageErrorDisplay');
      this.passDataService.setAnalyzerStatisticsErrorIconVal(this.analyzerStatisticsError);
      this.passDataService.setMortgageInsCoverageRes(null);
    }

    if (!isNullOrUndefined(this.collateralAnalyzerStatisticsComponent)) {
      this.collateralAnalyzerStatisticsComponent.handleInsuranceCoverageeError(error);
    }
    this.showAllStatisticsCallFailure();
  }

  public handleStatisticsTabUnits500ErrorCode(error: any): void {
    if (error === 'unitsError') {
      this.analyzerStatisticsError.push('unitsErrorDisplay');
      this.passDataService.setAnalyzerStatisticsErrorIconVal(this.analyzerStatisticsError);
      this.passDataService.setNumberOfUnitsRes(null);
    }

    if (!isNullOrUndefined(this.collateralAnalyzerStatisticsComponent)) {
      this.collateralAnalyzerStatisticsComponent.handleUnitsError(error);
    }
    this.showAllStatisticsCallFailure();
  }

  public handleStatisticsTabServicerDistribution500ErrorCode(error: any): void {
    if (error === 'servicerError') {
      this.analyzerStatisticsError.push('servicerErrorDisplay');
      this.passDataService.setAnalyzerStatisticsErrorIconVal(this.analyzerStatisticsError);
      this.passDataService.setServicersRes(null);
    }

    if (!isNullOrUndefined(this.collateralAnalyzerStatisticsComponent)) {
      this.collateralAnalyzerStatisticsComponent.handleServicerDistributionError(error);
    }
    this.showAllStatisticsCallFailure();
  }

  public handleStatisticsTabOriginationYear500ErrorCode(error: any): void {
    if (error === 'originationYearError') {
      this.analyzerStatisticsError.push('originationYearErrorDisplay');
      this.passDataService.setAnalyzerStatisticsErrorIconVal(this.analyzerStatisticsError);
      this.passDataService.setOriginationYearRes(null);
    }

    if (!isNullOrUndefined(this.collateralAnalyzerStatisticsComponent)) {
      this.collateralAnalyzerStatisticsComponent.handleOriginationYearError(error);
    }
    this.showAllStatisticsCallFailure();
  }

  public handleStatisticsTabQuartilemortgageLoanAmount500ErrorCode(error: any): void {
    if (error === 'quartileMortgageLoanAmountError') {
      this.analyzerStatisticsError.push('quartileMortgageLoanAmountErrorDisplay');
      this.passDataService.setAnalyzerStatisticsErrorIconVal(this.analyzerStatisticsError);
      this.passDataService.setMortgageLoanAmountQuartileRes(null);
    }

    if (!isNullOrUndefined(this.collateralAnalyzerStatisticsComponent)) {
      this.collateralAnalyzerStatisticsComponent.handleQuartileMortgageLoanAmountError(error);
    }
    this.showAllStatisticsCallFailure();
  }

  public handleStatisticsTabQuartileinterestRate500ErrorCode(error: any): void {
    if (error === 'quartileInterestRateError') {
      this.analyzerStatisticsError.push('quartileInterestRateErrorDisplay');
      this.passDataService.setAnalyzerStatisticsErrorIconVal(this.analyzerStatisticsError);
      this.passDataService.setInterestRateQuartileRes(null);
    }

    if (!isNullOrUndefined(this.collateralAnalyzerStatisticsComponent)) {
      this.collateralAnalyzerStatisticsComponent.handleQuartileInterestRateError(error);
    }
    this.showAllStatisticsCallFailure();
  }

  public handleStatisticsTabQuartilenetInterestRate500ErrorCode(error: any): void {
    if (error === 'quartileNetInterestRateError') {
      this.analyzerStatisticsError.push('quartileNetInterestRateErrorDisplay');
      this.passDataService.setAnalyzerStatisticsErrorIconVal(this.analyzerStatisticsError);
      this.passDataService.setNetInterestRateCurrentQuartileRes(null);
    }

    if (!isNullOrUndefined(this.collateralAnalyzerStatisticsComponent)) {
      this.collateralAnalyzerStatisticsComponent.handleQuartileNetInterestRateError(error);
    }
    this.showAllStatisticsCallFailure();
  }

  public handleStatisticsTabQuartileloanTerm500ErrorCode(error: any): void {
    if (error === 'quartileLoanTermError') {
      this.analyzerStatisticsError.push('quartileLoanTermErrorDisplay');
      this.passDataService.setAnalyzerStatisticsErrorIconVal(this.analyzerStatisticsError);
      this.passDataService.setLoanTermQuartileRes(null);
    }

    if (!isNullOrUndefined(this.collateralAnalyzerStatisticsComponent)) {
      this.collateralAnalyzerStatisticsComponent.handleQuartileLoanTermError(error);
    }
    this.showAllStatisticsCallFailure();
  }

  public handleStatisticsTabQuartileloanAge500ErrorCode(error: any): void {
    if (error === 'quartileLoanAgeError') {
      this.analyzerStatisticsError.push('quartileLoanAgeErrorDisplay');
      this.passDataService.setAnalyzerStatisticsErrorIconVal(this.analyzerStatisticsError);
      this.passDataService.setloanAgeQuartileRes(null);
    }

    if (!isNullOrUndefined(this.collateralAnalyzerStatisticsComponent)) {
      this.collateralAnalyzerStatisticsComponent.handleQuartileLoanAgeError(error);
    }
    this.showAllStatisticsCallFailure();
  }

  public handleStatisticsTabQuartileloanToValue500ErrorCode(error: any): void {
    if (error === 'quartileLoanToValueError') {
      this.analyzerStatisticsError.push('quartileLoanToValueErrorDisplay');
      this.passDataService.setAnalyzerStatisticsErrorIconVal(this.analyzerStatisticsError);
      this.passDataService.setLoanToValueQuartileRes(null);
    }

    if (!isNullOrUndefined(this.collateralAnalyzerStatisticsComponent)) {
      this.collateralAnalyzerStatisticsComponent.handleQuartileLoanToValueError(error);
    }
    this.showAllStatisticsCallFailure();
  }

  public handleStatisticsTabQuartilecombinedLoanToValue500ErrorCode(error: any): void {
    if (error === 'quartileCombinedLoanToValueError') {
      this.analyzerStatisticsError.push('quartileCombinedLoanToValueErrorDisplay');
      this.passDataService.setAnalyzerStatisticsErrorIconVal(this.analyzerStatisticsError);
      this.passDataService.setCombinedLoanToValueQuartileRes(null);
    }

    if (!isNullOrUndefined(this.collateralAnalyzerStatisticsComponent)) {
      this.collateralAnalyzerStatisticsComponent.handleQuartileCombinedLoanToValueError(error);
    }
    this.showAllStatisticsCallFailure();
  }

  public handleStatisticsTabQuartileborrowerCreditScore500ErrorCode(error: any): void {
    if (error === 'quartileBorrowerCreditScoreError') {
      this.analyzerStatisticsError.push('quartileBorrowerCreditScoreErrorDisplay');
      this.passDataService.setAnalyzerStatisticsErrorIconVal(this.analyzerStatisticsError);
      this.passDataService.setBorrowerCreditScoreQuartileRes(null);
    }

    if (!isNullOrUndefined(this.collateralAnalyzerStatisticsComponent)) {
      this.collateralAnalyzerStatisticsComponent.handleQuartileBorrowerCreditScoreError(error);
    }
    this.showAllStatisticsCallFailure();
  }

  public handleStatisticsTabQuartileremainingMonthsToMaturity500ErrorCode(error: any): void {
    if (error === 'quartileRemainingMonthsToMaturityError') {
      this.analyzerStatisticsError.push('quartileRemainingMonthsToMaturityErrorDisplay');
      this.passDataService.setAnalyzerStatisticsErrorIconVal(this.analyzerStatisticsError);
      this.passDataService.setRemainingMonthsToMaturityQuartileRes(null);
    }

    if (!isNullOrUndefined(this.collateralAnalyzerStatisticsComponent)) {
      this.collateralAnalyzerStatisticsComponent.handleQuartileRemainingMonthsToMaturityError(
        error,
      );
    }
    this.showAllStatisticsCallFailure();
  }

  public handleStatisticsTab500ErrorCode(): void {
    this.analyzerDisclosureErrorMsg = StringConstants.ANALYZER_DISCLOSURE_DATA_ERROR;
    this.passDataService.setLoanPurposeRes(null);
    this.passDataService.setPropertyTypeRes(null);
    this.passDataService.setChannelRes(null);
    this.passDataService.setoccupancyStatusRes(null);
    this.passDataService.setNumberOfUnitsRes(null);
    this.passDataService.setOriginationYearRes(null);
    this.passDataService.setStateRes(null);
    this.passDataService.setServicersRes(null);
    this.passDataService.setBorrowersRes(null);
    this.passDataService.setMortgageInsCancelIndRes(null);
    this.passDataService.setMortgageInsCoverageRes(null);
    this.passDataService.setMortgageLoanAmountQuartileRes(null);
    this.passDataService.setInterestRateQuartileRes(null);
    this.passDataService.setNetInterestRateCurrentQuartileRes(null);
    this.passDataService.setLoanTermQuartileRes(null);
    this.passDataService.setloanAgeQuartileRes(null);
    this.passDataService.setLoanToValueQuartileRes(null);
    this.passDataService.setCombinedLoanToValueQuartileRes(null);
    this.passDataService.setBorrowerCreditScoreQuartileRes(null);
    this.passDataService.setRemainingMonthsToMaturityQuartileRes(null);
    this.passDataService.setQuartileCompleteRes(null);
    this.passDataService.setServicersLessThanOnePercentRes(null);
    this.analyzerStatisticsTabError = true;
    this.enablePDFButton = true;
    this.passDataService.setDisclosurePDFButton(this.enablePDFButton);
    this.passDataService.setAnalyzerStatisticsTmpMegaError(this.analyzerStatisticsTabError);
  }

  public servicersDetailsPDFResolved(): any {
    const servicers = this.passDataService.getServicersRes();

    this.servicersResResolved = this.servicerLessThanOnePercent(servicers);
  }

  public servicerLessThanOnePercent(servicers): any {
    const servicerResResolved = [];
    const mBundleLessThanOnePercent: any = {};
    let aggUPBLessThan1Percent = 0;
    let loanCountLessThan1Percent = 0;
    let pctAggUPBLessThan1Percent = 0;
    let pctLoanCountLessThan1Percent = 0;

    if (servicers) {
      servicers.forEach((item) => {
        const mBundle: any = {};

        if (item.pctAggUPB < 1) {
          aggUPBLessThan1Percent = aggUPBLessThan1Percent + parseFloat(item.aggUPB);
          loanCountLessThan1Percent = loanCountLessThan1Percent + parseFloat(item.loanCount);
          pctAggUPBLessThan1Percent = pctAggUPBLessThan1Percent + parseFloat(item.pctAggUPB);
          pctLoanCountLessThan1Percent =
            pctLoanCountLessThan1Percent + parseFloat(item.pctLoanCount);
        } else {
          mBundle.recTypeValue = item.recTypeValue;
          mBundle.aggUPB = item.aggUPB;
          mBundle.loanCount = item.loanCount;
          mBundle.pctAggUPB = item.pctAggUPB;
          mBundle.pctLoanCount = item.pctLoanCount;
        }

        if (!isNullOrUndefined(mBundle.recTypeValue)) {
          servicerResResolved.push(mBundle);
        }
      });
    }

    mBundleLessThanOnePercent.recTypeValue = 'LESS THAN 1%';
    mBundleLessThanOnePercent.aggUPB = aggUPBLessThan1Percent;
    mBundleLessThanOnePercent.loanCount = loanCountLessThan1Percent;
    mBundleLessThanOnePercent.pctAggUPB =
      pctAggUPBLessThan1Percent && pctAggUPBLessThan1Percent.toFixed(2);
    mBundleLessThanOnePercent.pctLoanCount =
      pctLoanCountLessThan1Percent && pctLoanCountLessThan1Percent.toFixed(2);

    if (aggUPBLessThan1Percent && aggUPBLessThan1Percent !== 0) {
      servicerResResolved.push(mBundleLessThanOnePercent);
    }

    this.passDataService.setServicersLessThanOnePercentRes(servicerResResolved);
    return servicerResResolved;
  }

  public showQuartileResResolved(): void {
    this.mortgageLoanAmountQuartileResResolved =
      this.passDataService.getMortgageLoanAmountQuartileRes();
    this.interestRateQuartileResResolved = this.passDataService.getInterestRateQuartileRes();
    this.netInterestRateCurrentQuartileResResolved =
      this.passDataService.getNetInterestRateCurrentQuartileRes();
    this.loanTermQuartileResResolved = this.passDataService.getLoanTermQuartileRes();
    this.loanAgeQuartileResResolved = this.passDataService.getloanAgeQuartileRes();
    this.loanToValueQuartileResResolved = this.passDataService.getLoanToValueQuartileRes();
    this.combinedLoanToValueQuartileResResolved =
      this.passDataService.getCombinedLoanToValueQuartileRes();
    this.borrowerCreditScoreQuartileResResolved =
      this.passDataService.getBorrowerCreditScoreQuartileRes();
    this.remainingMonthsToMaturityQuartileResResolved =
      this.passDataService.getRemainingMonthsToMaturityQuartileRes();
    this.frameQuartileResponse();
  }

  public frameQuartileResponse(): void {
    const mBundlemaximum: any = {};
    const mBundlemedian: any = {};
    const mBundleminimum: any = {};
    const mBundleq25pct: any = {};
    const mBundleq75pct: any = {};
    this.quartileRes = [];

    mBundlemaximum.attribute = 'Maximum';
    mBundlemaximum.mortgageLoanAmount =
      this.mortgageLoanAmountQuartileResResolved &&
      this.mortgageLoanAmountQuartileResResolved.mortgageLoanAmount &&
      this.mortgageLoanAmountQuartileResResolved.mortgageLoanAmount[0].maximum;
    mBundlemaximum.interestRate =
      this.interestRateQuartileResResolved &&
      this.interestRateQuartileResResolved.interestRate &&
      this.interestRateQuartileResResolved.interestRate[0].maximum;
    mBundlemaximum.netInterestRate_Current =
      this.netInterestRateCurrentQuartileResResolved &&
      this.netInterestRateCurrentQuartileResResolved.netInterestRate_Current &&
      this.netInterestRateCurrentQuartileResResolved.netInterestRate_Current[0].maximum;
    mBundlemaximum.loanTerm =
      this.loanTermQuartileResResolved &&
      this.loanTermQuartileResResolved.loanTerm &&
      parseInt(this.loanTermQuartileResResolved.loanTerm[0].maximum, 10);
    mBundlemaximum.loanAge =
      this.loanAgeQuartileResResolved &&
      this.loanAgeQuartileResResolved.loanAge &&
      parseInt(this.loanAgeQuartileResResolved.loanAge[0].maximum, 10);
    mBundlemaximum.loanToValue =
      this.loanToValueQuartileResResolved &&
      this.loanToValueQuartileResResolved.loanToValue &&
      parseInt(this.loanToValueQuartileResResolved.loanToValue[0].maximum, 10);
    mBundlemaximum.combined_LoanToValue =
      this.combinedLoanToValueQuartileResResolved &&
      this.combinedLoanToValueQuartileResResolved.combined_LoanToValue &&
      parseInt(this.combinedLoanToValueQuartileResResolved.combined_LoanToValue[0].maximum, 10);
    mBundlemaximum.borrowerCreditScore =
      this.borrowerCreditScoreQuartileResResolved &&
      this.borrowerCreditScoreQuartileResResolved.borrowerCreditScore &&
      parseInt(this.borrowerCreditScoreQuartileResResolved.borrowerCreditScore[0].maximum, 10);
    mBundlemaximum.remainingMonthsToMaturity =
      this.remainingMonthsToMaturityQuartileResResolved &&
      this.remainingMonthsToMaturityQuartileResResolved.remainingMonthsToMaturity &&
      parseInt(
        this.remainingMonthsToMaturityQuartileResResolved.remainingMonthsToMaturity[0].maximum,
        10,
      );
    mBundlemaximum.DTI = '-';

    mBundleq75pct.attribute = '75%';
    mBundleq75pct.mortgageLoanAmount =
      this.mortgageLoanAmountQuartileResResolved &&
      this.mortgageLoanAmountQuartileResResolved.mortgageLoanAmount &&
      this.mortgageLoanAmountQuartileResResolved.mortgageLoanAmount[0].q75pct;
    mBundleq75pct.interestRate =
      this.interestRateQuartileResResolved &&
      this.interestRateQuartileResResolved.interestRate &&
      this.interestRateQuartileResResolved.interestRate[0].q75pct;
    mBundleq75pct.netInterestRate_Current =
      this.netInterestRateCurrentQuartileResResolved &&
      this.netInterestRateCurrentQuartileResResolved.netInterestRate_Current &&
      this.netInterestRateCurrentQuartileResResolved.netInterestRate_Current[0].q75pct;
    mBundleq75pct.loanTerm =
      this.loanTermQuartileResResolved &&
      this.loanTermQuartileResResolved.loanTerm &&
      parseInt(this.loanTermQuartileResResolved.loanTerm[0].q75pct, 10);
    mBundleq75pct.loanAge =
      this.loanAgeQuartileResResolved &&
      this.loanAgeQuartileResResolved.loanAge &&
      parseInt(this.loanAgeQuartileResResolved.loanAge[0].q75pct, 10);
    mBundleq75pct.loanToValue =
      this.loanToValueQuartileResResolved &&
      this.loanToValueQuartileResResolved.loanToValue &&
      parseInt(this.loanToValueQuartileResResolved.loanToValue[0].q75pct, 10);
    mBundleq75pct.combined_LoanToValue =
      this.combinedLoanToValueQuartileResResolved &&
      this.combinedLoanToValueQuartileResResolved.combined_LoanToValue &&
      parseInt(this.combinedLoanToValueQuartileResResolved.combined_LoanToValue[0].q75pct, 10);
    mBundleq75pct.borrowerCreditScore =
      this.borrowerCreditScoreQuartileResResolved &&
      this.borrowerCreditScoreQuartileResResolved.borrowerCreditScore &&
      parseInt(this.borrowerCreditScoreQuartileResResolved.borrowerCreditScore[0].q75pct, 10);
    mBundleq75pct.remainingMonthsToMaturity =
      this.remainingMonthsToMaturityQuartileResResolved &&
      this.remainingMonthsToMaturityQuartileResResolved.remainingMonthsToMaturity &&
      parseInt(
        this.remainingMonthsToMaturityQuartileResResolved.remainingMonthsToMaturity[0].q75pct,
        10,
      );
    mBundleq75pct.DTI = '-';

    mBundlemedian.attribute = 'Median';
    mBundlemedian.mortgageLoanAmount =
      this.mortgageLoanAmountQuartileResResolved &&
      this.mortgageLoanAmountQuartileResResolved.mortgageLoanAmount &&
      this.mortgageLoanAmountQuartileResResolved.mortgageLoanAmount[0].median;
    mBundlemedian.interestRate =
      this.interestRateQuartileResResolved &&
      this.interestRateQuartileResResolved.interestRate &&
      this.interestRateQuartileResResolved.interestRate[0].median;
    mBundlemedian.netInterestRate_Current =
      this.netInterestRateCurrentQuartileResResolved &&
      this.netInterestRateCurrentQuartileResResolved.netInterestRate_Current &&
      this.netInterestRateCurrentQuartileResResolved.netInterestRate_Current[0].median;
    mBundlemedian.loanTerm =
      this.loanTermQuartileResResolved &&
      this.loanTermQuartileResResolved.loanTerm &&
      parseInt(this.loanTermQuartileResResolved.loanTerm[0].median, 10);
    mBundlemedian.loanAge =
      this.loanAgeQuartileResResolved &&
      this.loanAgeQuartileResResolved.loanAge &&
      parseInt(this.loanAgeQuartileResResolved.loanAge[0].median, 10);
    mBundlemedian.loanToValue =
      this.loanToValueQuartileResResolved &&
      this.loanToValueQuartileResResolved.loanToValue &&
      parseInt(this.loanToValueQuartileResResolved.loanToValue[0].median, 10);
    mBundlemedian.combined_LoanToValue =
      this.combinedLoanToValueQuartileResResolved &&
      this.combinedLoanToValueQuartileResResolved.combined_LoanToValue &&
      parseInt(this.combinedLoanToValueQuartileResResolved.combined_LoanToValue[0].median, 10);
    mBundlemedian.borrowerCreditScore =
      this.borrowerCreditScoreQuartileResResolved &&
      this.borrowerCreditScoreQuartileResResolved.borrowerCreditScore &&
      parseInt(this.borrowerCreditScoreQuartileResResolved.borrowerCreditScore[0].median, 10);
    mBundlemedian.remainingMonthsToMaturity =
      this.remainingMonthsToMaturityQuartileResResolved &&
      this.remainingMonthsToMaturityQuartileResResolved.remainingMonthsToMaturity &&
      parseInt(
        this.remainingMonthsToMaturityQuartileResResolved.remainingMonthsToMaturity[0].median,
        10,
      );
    mBundlemedian.DTI = '-';

    mBundleq25pct.attribute = '25%';
    mBundleq25pct.mortgageLoanAmount =
      this.mortgageLoanAmountQuartileResResolved &&
      this.mortgageLoanAmountQuartileResResolved.mortgageLoanAmount &&
      this.mortgageLoanAmountQuartileResResolved.mortgageLoanAmount[0].q25pct;
    mBundleq25pct.interestRate =
      this.interestRateQuartileResResolved &&
      this.interestRateQuartileResResolved.interestRate &&
      this.interestRateQuartileResResolved.interestRate[0].q25pct;
    mBundleq25pct.netInterestRate_Current =
      this.netInterestRateCurrentQuartileResResolved &&
      this.netInterestRateCurrentQuartileResResolved.netInterestRate_Current &&
      this.netInterestRateCurrentQuartileResResolved.netInterestRate_Current[0].q25pct;
    mBundleq25pct.loanTerm =
      this.loanTermQuartileResResolved &&
      this.loanTermQuartileResResolved.loanTerm &&
      parseInt(this.loanTermQuartileResResolved.loanTerm[0].q25pct, 10);
    mBundleq25pct.loanAge =
      this.loanAgeQuartileResResolved &&
      this.loanAgeQuartileResResolved.loanAge &&
      parseInt(this.loanAgeQuartileResResolved.loanAge[0].q25pct, 10);
    mBundleq25pct.loanToValue =
      this.loanToValueQuartileResResolved &&
      this.loanToValueQuartileResResolved.loanToValue &&
      parseInt(this.loanToValueQuartileResResolved.loanToValue[0].q25pct, 10);
    mBundleq25pct.combined_LoanToValue =
      this.combinedLoanToValueQuartileResResolved &&
      this.combinedLoanToValueQuartileResResolved.combined_LoanToValue &&
      parseInt(this.combinedLoanToValueQuartileResResolved.combined_LoanToValue[0].q25pct, 10);
    mBundleq25pct.borrowerCreditScore =
      this.borrowerCreditScoreQuartileResResolved &&
      this.borrowerCreditScoreQuartileResResolved.borrowerCreditScore &&
      parseInt(this.borrowerCreditScoreQuartileResResolved.borrowerCreditScore[0].q25pct, 10);
    mBundleq25pct.remainingMonthsToMaturity =
      this.remainingMonthsToMaturityQuartileResResolved &&
      this.remainingMonthsToMaturityQuartileResResolved.remainingMonthsToMaturity &&
      parseInt(
        this.remainingMonthsToMaturityQuartileResResolved.remainingMonthsToMaturity[0].q25pct,
        10,
      );
    mBundleq25pct.DTI = '-';

    mBundleminimum.attribute = 'Minimum';
    mBundleminimum.mortgageLoanAmount =
      this.mortgageLoanAmountQuartileResResolved &&
      this.mortgageLoanAmountQuartileResResolved.mortgageLoanAmount &&
      this.mortgageLoanAmountQuartileResResolved.mortgageLoanAmount[0].minimum;
    mBundleminimum.interestRate =
      this.interestRateQuartileResResolved &&
      this.interestRateQuartileResResolved.interestRate &&
      this.interestRateQuartileResResolved.interestRate[0].minimum;
    mBundleminimum.netInterestRate_Current =
      this.netInterestRateCurrentQuartileResResolved &&
      this.netInterestRateCurrentQuartileResResolved.netInterestRate_Current &&
      this.netInterestRateCurrentQuartileResResolved.netInterestRate_Current[0].minimum;
    mBundleminimum.loanTerm =
      this.loanTermQuartileResResolved &&
      this.loanTermQuartileResResolved.loanTerm &&
      parseInt(this.loanTermQuartileResResolved.loanTerm[0].minimum, 10);
    mBundleminimum.loanAge =
      this.loanAgeQuartileResResolved &&
      this.loanAgeQuartileResResolved.loanAge &&
      parseInt(this.loanAgeQuartileResResolved.loanAge[0].minimum, 10);
    mBundleminimum.loanToValue =
      this.loanToValueQuartileResResolved &&
      this.loanToValueQuartileResResolved.loanToValue &&
      parseInt(this.loanToValueQuartileResResolved.loanToValue[0].minimum, 10);
    mBundleminimum.combined_LoanToValue =
      this.combinedLoanToValueQuartileResResolved &&
      this.combinedLoanToValueQuartileResResolved.combined_LoanToValue &&
      parseInt(this.combinedLoanToValueQuartileResResolved.combined_LoanToValue[0].minimum, 10);
    mBundleminimum.borrowerCreditScore =
      this.borrowerCreditScoreQuartileResResolved &&
      this.borrowerCreditScoreQuartileResResolved.borrowerCreditScore &&
      parseInt(this.borrowerCreditScoreQuartileResResolved.borrowerCreditScore[0].minimum, 10);
    mBundleminimum.remainingMonthsToMaturity =
      this.remainingMonthsToMaturityQuartileResResolved &&
      this.remainingMonthsToMaturityQuartileResResolved.remainingMonthsToMaturity &&
      parseInt(
        this.remainingMonthsToMaturityQuartileResResolved.remainingMonthsToMaturity[0].minimum,
        10,
      );
    mBundleminimum.DTI = '-';

    this.quartileRes.push(mBundlemaximum);
    this.quartileRes.push(mBundleq75pct);
    this.quartileRes.push(mBundlemedian);
    this.quartileRes.push(mBundleq25pct);
    this.quartileRes.push(mBundleminimum);

    this.passDataService.setQuartileCompleteRes(this.quartileRes);
  }

  public disclosureDetailsResetBeforeCall(): void {
    this.disclosureWaDetailsRes = null;
    this.disclosureSellerDetailsRes = null;

    this.loanPurposeRes = null;
    this.propertyTypeRes = null;
    this.channelRes = null;
    this.occupancyStatusRes = null;
    this.numberOfUnitsRes = null;
    this.originationYearRes = null;
    this.stateRes = null;
    this.servicersRes = null;
    this.borrowersRes = null;
    this.mortgageInsCancelIndRes = null;
    this.mortgageInsCoverageRes = null;

    this.mortgageLoanAmountQuartileRes = null;
    this.interestRateQuartileRes = null;
    this.netInterestRateCurrentQuartileRes = null;
    this.loanTermQuartileRes = null;
    this.loanAgeQuartileRes = null;
    this.loanToValueQuartileRes = null;
    this.combinedLoanToValueQuartileRes = null;
    this.borrowerCreditScoreQuartileRes = null;
    this.remainingMonthsToMaturityQuartileRes = null;
    this.analyzerStatisticsError = [];
    this.analyzerDetailsError = [];

    this.passDataService.setDisclosureSellerDetailsRes(null);
    this.passDataService.setDisclosureWaDetailsRes(null);

    this.passDataService.setLoanPurposeRes(null);
    this.passDataService.setPropertyTypeRes(null);
    this.passDataService.setChannelRes(null);
    this.passDataService.setoccupancyStatusRes(null);
    this.passDataService.setNumberOfUnitsRes(null);
    this.passDataService.setOriginationYearRes(null);
    this.passDataService.setStateRes(null);
    this.passDataService.setServicersRes(null);
    this.passDataService.setBorrowersRes(null);
    this.passDataService.setMortgageInsCancelIndRes(null);
    this.passDataService.setMortgageInsCoverageRes(null);
    this.passDataService.setMortgageLoanAmountQuartileRes(null);
    this.passDataService.setInterestRateQuartileRes(null);
    this.passDataService.setNetInterestRateCurrentQuartileRes(null);
    this.passDataService.setLoanTermQuartileRes(null);
    this.passDataService.setloanAgeQuartileRes(null);
    this.passDataService.setLoanToValueQuartileRes(null);
    this.passDataService.setCombinedLoanToValueQuartileRes(null);
    this.passDataService.setBorrowerCreditScoreQuartileRes(null);
    this.passDataService.setRemainingMonthsToMaturityQuartileRes(null);
    this.passDataService.setQuartileCompleteRes(null);
    this.passDataService.setServicersLessThanOnePercentRes(null);
    this.passDataService.setAnalyzerDetailsErrorIconVal(null);
    this.passDataService.setAnalyzerStatisticsErrorIconVal(null);
    this.passDataService.setAnalyzerStatisticsQuartileErrorIconVal(null);
    this.passDataService.setGoBackEditFlag(null);
    this.passDataService.setAnalyzerStatisticsTmpMegaError(null);
    this.passDataService.setAnalyzerDetailsTmpMegaError(null);
    this.passDataService.setDisclosurePDFButton(null);
  }

  public showAllDetailsCallFailure(): void {
    if (
      this.analyzerDetailsError.includes('showWaError') &&
      this.analyzerDetailsError.includes('showSellerError')
    ) {
      this.analyzerDisclosureErrorMsg = StringConstants.ANALYZER_DISCLOSURE_DATA_ERROR;
      this.analyzerDetailsTabError = true;
      this.enablePDFButton = true;
      this.passDataService.setDisclosurePDFButton(this.enablePDFButton);
      this.passDataService.setAnalyzerDetailsTmpMegaError(this.analyzerDetailsTabError);
    }
  }

  public showAllStatisticsCallFailure(): void {
    if (this.analyzerStatisticsError && this.analyzerStatisticsError.length === 20) {
      this.handleStatisticsTab500ErrorCode();
    }
  }

  public navigateToHome(): void {
    this.router.navigate(['/']);
  }

  public removeDateTimestamp(dateArray: any): any {
    const dateArrayTemp = [];
    dateArray.forEach((element) => {
      let tempDate = '';
      tempDate = element && element.split('T')[0];
      dateArrayTemp.push(tempDate);
    });
    return dateArrayTemp;
  }

  public onDateChanged(date: IMyDateModel) {
    this.dateSelected = date.singleDate.jsDate;
  }

  protected trackByIdentity(_index: number, obj: any) {
    return obj;
  }
}
